export const codigosCids = [
  {
    nm: null,
    nome: 'OUTROS PRODUTOS ANORMAIS DA CONCEPÇÃO',
    codigo: 'O02',
    id_grupo: 'ABORTO',
  },
  { nm: null, nome: 'ABORTO RETIDO', codigo: 'O021', id_grupo: 'ABORTO' },
  { nm: null, nome: 'ABORTO ESPONTÂNEO', codigo: 'O03', id_grupo: 'ABORTO' },
  {
    nm: null,
    nome: 'ABORTO POR RAZÕES MEDICAS E LEGAIS',
    codigo: 'O04',
    id_grupo: 'ABORTO',
  },
  {
    nm: null,
    nome: 'OUTROS TIPOS DE ABORTO',
    codigo: 'O05',
    id_grupo: 'ABORTO',
  },
  {
    nm: null,
    nome: 'ABORTO NÃO ESPECIFICADO',
    codigo: 'O06',
    id_grupo: 'ABORTO',
  },
  { nm: null, nome: 'EXTRAÇÃO MENSTRUAL', codigo: 'Z303', id_grupo: 'ABORTO' },
  { nm: null, nome: 'ASMA', codigo: 'J45', id_grupo: 'ASMA' },
  {
    nm: null,
    nome: 'ASMA PREDOMINANTEMENTE ALÉRGICA',
    codigo: 'J450',
    id_grupo: 'ASMA',
  },
  { nm: null, nome: 'ASMA NÃO-ALÉRGICA', codigo: 'J451', id_grupo: 'ASMA' },
  { nm: null, nome: 'ASMA MISTA', codigo: 'J458', id_grupo: 'ASMA' },
  { nm: null, nome: 'ASMA NÃO ESPECIFICADA', codigo: 'J459', id_grupo: 'ASMA' },
  { nm: null, nome: 'ESTADO DE MAL ASMÁTICO', codigo: 'J46', id_grupo: 'ASMA' },
  {
    nm: null,
    nome: 'ACIDENTES VASCULARES CEREBRAIS ISQUÊMICOS TRANSITÓRIOS E SÍNDROMES CORRELATAS',
    codigo: 'G45',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'SÍNDROMES VASCULARES CEREBRAIS QUE OCORREM EM DOENÇAS CEREBROVASCULARES',
    codigo: 'G46',
    id_grupo: 'AVC',
  },
  { nm: null, nome: 'HEMORRAGIA SUBARACNÓIDE', codigo: 'I60', id_grupo: 'AVC' },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL',
    codigo: 'I61',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL HEMISFÉRICA SUBCORTICAL',
    codigo: 'I610',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL HEMISFÉRICA CORTICAL',
    codigo: 'I611',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL HEMISFÉRICA NÃO ESPECIFICADA',
    codigo: 'I612',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL DO TRONCO CEREBRAL',
    codigo: 'I613',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL CEREBELAR',
    codigo: 'I614',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL INTRAVENTRICULAR',
    codigo: 'I615',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL DE MÚLTIPLAS LOCALIZAÇÕES',
    codigo: 'I616',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'OUTRAS HEMORRAGIAS INTRACEREBRAIS',
    codigo: 'I618',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTRACEREBRAL NÃO ESPECIFICADA',
    codigo: 'I619',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'OUTRAS HEMORRAGIAS INTRACRANIANAS NÃO-TRAUMÁTICAS',
    codigo: 'I62',
    id_grupo: 'AVC',
  },
  { nm: null, nome: 'INFARTO CEREBRAL', codigo: 'I63', id_grupo: 'AVC' },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL DEVIDO A TROMBOSE DE ARTÉRIAS PRÉ-CEREBRAIS',
    codigo: 'I630',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL DEVIDO A EMBOLIA DE ARTÉRIAS PRÉ-CEREBRAIS',
    codigo: 'I631',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL DEVIDO A OCLUSÃO OU ESTENOSE NÃO ESPECIFICADAS DE ARTÉRIAS PRÉ-CEREBRAIS',
    codigo: 'I632',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL DEVIDO A TROMBOSE DE ARTÉRIAS CEREBRAIS',
    codigo: 'I633',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL DEVIDO A EMBOLIA DE ARTÉRIAS CEREBRAIS',
    codigo: 'I634',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL DEVIDO A OCLUSÃO OU ESTENOSE NÃO ESPECIFICADAS DE ARTÉRIAS CEREBRAIS',
    codigo: 'I635',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL DEVIDO A TROMBOSE VENOSA CEREBRAL NÃO-PIOGÊNICA',
    codigo: 'I636',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'OUTROS INFARTOS CEREBRAIS',
    codigo: 'I638',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'INFARTO CEREBRAL NÃO ESPECIFICADO',
    codigo: 'I639',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'ACIDENTE VASCULAR CEREBRAL, NÃO ESPECIFICADO COMO HEMORRÁGICO OU ISQUÊMICO',
    codigo: 'I64',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'OCLUSÃO E ESTENOSE DE ARTÉRIAS PRÉ-CEREBRAIS QUE NÃO RESULTAM EM INFARTO CEREBRAL',
    codigo: 'I65',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'OCLUSÃO E ESTENOSE DE ARTÉRIAS CEREBRAIS QUE NÃO RESULTAM EM INFARTO CEREBRAL',
    codigo: 'I66',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS CEREBROVASCULARES',
    codigo: 'I67',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'DISSECÇÃO DE ARTÉRIAS CEREBRAIS, SEM RUPTURA',
    codigo: 'I670',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'ANEURISMA CEREBRAL NÃO-ROTO',
    codigo: 'I671',
    id_grupo: 'AVC',
  },
  { nm: null, nome: 'ATEROSCLEROSE CEREBRAL', codigo: 'I672', id_grupo: 'AVC' },
  {
    nm: null,
    nome: 'LEUCOENCEFALOPATIA VASCULAR PROGRESSIVA',
    codigo: 'I673',
    id_grupo: 'AVC',
  },
  { nm: null, nome: 'DOENÇA DE MOYAMOYA', codigo: 'I675', id_grupo: 'AVC' },
  {
    nm: null,
    nome: 'TROMBOSE NÃO-PIOGÊNICA DO SISTEMA VENOSO INTRACRANIANO',
    codigo: 'I676',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'ARTERITE CEREBRAL NÃO CLASSIFICADA EM OUTRA PARTE',
    codigo: 'I677',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS CEREBROVASCULARES ESPECIFICADAS',
    codigo: 'I678',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'DOENÇA CEREBROVASCULAR NÃO ESPECIFICADA',
    codigo: 'I679',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS CEREBROVASCULARES EM DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'I68',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE DOENÇAS CEREBROVASCULARES',
    codigo: 'I69',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'DENGUE [DENGUE CLÁSSICO]',
    codigo: 'A90',
    id_grupo: 'DENGUE',
  },
  {
    nm: null,
    nome: 'FEBRE HEMORRÁGICA DEVIDA AO VÍRUS DO DENGUE',
    codigo: 'A91',
    id_grupo: 'DENGUE',
  },
  {
    nm: null,
    nome: 'SÍNDROMES MIELODISPLÁSICAS',
    codigo: 'D46',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA REFRATÁRIA SEM SIDEROBLASTOS',
    codigo: 'D460',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA REFRATÁRIA COM SIDEROBLASTOS',
    codigo: 'D461',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA REFRATÁRIA COM EXCESSO DE BLASTOS',
    codigo: 'D462',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA REFRATÁRIA COM EXCESSO DE BLASTOS COM TRANSFORMAÇÃO',
    codigo: 'D463',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA REFRATÁRIA, NÃO ESPECIFICADA',
    codigo: 'D464',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE FERRO',
    codigo: 'D50',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE FERRO SECUNDÁRIA À PERDA DE SANGUE (CRÔNICA)',
    codigo: 'D500',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS POR DEFICIÊNCIA DE FERRO',
    codigo: 'D508',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE FERRO NÃO ESPECIFICADA',
    codigo: 'D509',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE VITAMINA B12',
    codigo: 'D51',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE VITAMINA B12 DEVIDA À DEFICIÊNCIA DE FATOR INTRÍNSECO',
    codigo: 'D510',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE VITAMINA B12 DEVIDA À MÁ-ABSORÇÃO SELETIVA DE VITAMINA B12 COM PROTEINÚRIA',
    codigo: 'D511',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE TRANSCOBALAMINA II',
    codigo: 'D512',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS POR DEFICIÊNCIA DE VITAMINA B12 NA DIETA',
    codigo: 'D513',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS POR DEFICIÊNCIA DE VITAMINA B12',
    codigo: 'D518',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE VITAMINA B12 NÃO ESPECIFICADA',
    codigo: 'D519',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE FOLATO',
    codigo: 'D52',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE FOLATO NA DIETA',
    codigo: 'D520',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE FOLATO INDUZIDA POR DROGAS',
    codigo: 'D521',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS POR DEFICIÊNCIA DE FOLATO',
    codigo: 'D528',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE FOLATO NÃO ESPECIFICADA',
    codigo: 'D529',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS NUTRICIONAIS',
    codigo: 'D53',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA DE PROTEÍNAS',
    codigo: 'D530',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS MEGALOBLÁSTICAS NÃO CLASSIFICADAS EM OUTRAS PARTES',
    codigo: 'D531',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA ESCORBÚTICA',
    codigo: 'D532',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS NUTRICIONAIS ESPECIFICADAS',
    codigo: 'D538',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA NUTRICIONAL NÃO ESPECIFICADA',
    codigo: 'D539',
    id_grupo: 'DESNUTRICAO',
  },
  { nm: null, nome: 'KWASHIORKOR', codigo: 'E40', id_grupo: 'DESNUTRICAO' },
  {
    nm: null,
    nome: 'MARASMO NUTRICIONAL',
    codigo: 'E41',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'KWASHIORKOR MARASMÁTICO',
    codigo: 'E42',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESNUTRIÇÃO PROTÉICO-CALÓRICA GRAVE NÃO ESPECIFICADA',
    codigo: 'E43',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESNUTRIÇÃO PROTÉICO-CALÓRICA DE GRAUS MODERADO E LEVE',
    codigo: 'E44',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESNUTRIÇÃO PROTÉICO-CALÓRICA MODERADA',
    codigo: 'E440',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESNUTRIÇÃO PROTÉICO-CALÓRICA LEVE',
    codigo: 'E441',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ATRASO DO DESENVOLVIMENTO DEVIDO À DESNUTRIÇÃO PROTÉICO-CALÓRICA',
    codigo: 'E45',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESNUTRIÇÃO PROTÉICO-CALÓRICA NÃO ESPECIFICADA',
    codigo: 'E46',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A',
    codigo: 'E50',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A COM XEROSE CONJUNTIVAL',
    codigo: 'E500',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A COM MANCHA DE BITOT E XEROSE CONJUNTIVAL',
    codigo: 'E501',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A COM XEROSE DA CÓRNEA',
    codigo: 'E502',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A COM ULCERAÇÃO E XEROSE DA CÓRNEA',
    codigo: 'E503',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A COM CERATOMALÁCIA',
    codigo: 'E504',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A COM CEGUEIRA NOTURNA',
    codigo: 'E505',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA A COM CICATRIZES XEROFTÁLMICAS DA CÓRNEA',
    codigo: 'E506',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS MANIFESTAÇÕES OCULARES DEVIDAS A DEFICIÊNCIA DE VITAMINA A',
    codigo: 'E507',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS MANIFESTAÇÕES DEVIDAS A DEFICIÊNCIA DE VITAMINA A',
    codigo: 'E508',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA NÃO ESPECIFICADA DE VITAMINA A',
    codigo: 'E509',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE TIAMINA',
    codigo: 'E51',
    id_grupo: 'DESNUTRICAO',
  },
  { nm: null, nome: 'BERIBÉRI', codigo: 'E511', id_grupo: 'DESNUTRICAO' },
  {
    nm: null,
    nome: 'ENCEFALOPATIA DE WERNICKE',
    codigo: 'E512',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS MANIFESTAÇÕES DA DEFICIÊNCIA DE TIAMINA',
    codigo: 'E518',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA NÃO ESPECIFICADA DE TIAMINA',
    codigo: 'E519',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE NIACINA [PELAGRA]',
    codigo: 'E52',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE OUTRAS VITAMINAS DO GRUPO B',
    codigo: 'E53',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE RIBOFLAVINA',
    codigo: 'E530',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE PIRIDOXINA',
    codigo: 'E531',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE OUTRAS VITAMINAS ESPECIFICADAS DO GRUPO B',
    codigo: 'E538',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA NÃO ESPECIFICADA DE VITAMINA B',
    codigo: 'E539',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE ÁCIDO ASCÓRBICO',
    codigo: 'E54',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA D',
    codigo: 'E55',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'RAQUITISMO ATIVO',
    codigo: 'E550',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA NÃO ESPECIFICADA DE VITAMINA D',
    codigo: 'E559',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS DEFICIÊNCIAS VITAMÍNICAS',
    codigo: 'E56',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA E',
    codigo: 'E560',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VITAMINA K',
    codigo: 'E561',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE OUTRAS VITAMINAS',
    codigo: 'E568',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA VITAMÍNICA NÃO ESPECIFICADA',
    codigo: 'E569',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE CÁLCIO DA DIETA',
    codigo: 'E58',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE SELÊNIO DA DIETA',
    codigo: 'E59',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE ZINCO DA DIETA',
    codigo: 'E60',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE OUTROS ELEMENTOS NUTRIENTES',
    codigo: 'E61',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE COBRE',
    codigo: 'E610',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE FERRO',
    codigo: 'E611',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE MAGNÉSIO',
    codigo: 'E612',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE MANGANÊS',
    codigo: 'E613',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE CROMO',
    codigo: 'E614',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE MOLIBDÊNIO',
    codigo: 'E615',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE VANÁDIO',
    codigo: 'E616',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE MÚLTIPLOS ELEMENTOS NUTRIENTES',
    codigo: 'E617',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE OUTROS ELEMENTOS NUTRIENTES ESPECIFICADOS',
    codigo: 'E618',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE ELEMENTOS NUTRIENTES NÃO ESPECIFICADOS',
    codigo: 'E619',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS DEFICIÊNCIAS NUTRICIONAIS',
    codigo: 'E63',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA DE ÁCIDO GRAXO ESSENCIAL',
    codigo: 'E630',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESEQUILÍBRIO DE CONSTITUINTES DA INGESTÃO DE ALIMENTOS',
    codigo: 'E631',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS DEFICIÊNCIAS NUTRICIONAIS ESPECIFICADAS',
    codigo: 'E638',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA NUTRICIONAL NÃO ESPECIFICADA',
    codigo: 'E639',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESNUTRICAO NA GRAVIDEZ',
    codigo: 'O25',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O990',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'RECÉM-NASCIDO DE BAIXO PESO PARA A IDADE GESTACIONAL',
    codigo: 'P050',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DESNUTRIÇÃO FETAL SEM MENÇÃO DE PESO E COMPRIMENTO BAIXOS PARA A IDADE GESTACIONAL',
    codigo: 'P052',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE',
    codigo: 'E10',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMA',
    codigo: 'E100',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM CETOACIDOSE',
    codigo: 'E101',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES RENAIS',
    codigo: 'E102',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES OFTÁLMICAS',
    codigo: 'E103',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES NEUROLÓGICAS',
    codigo: 'E104',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES CIRCULATÓRIAS PERIFÉRICAS',
    codigo: 'E105',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM OUTRAS COMPLICAÇÕES ESPECIFICADAS',
    codigo: 'E106',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES MÚLTIPLAS',
    codigo: 'E107',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - COM COMPLICAÇÕES NÃO ESPECIFICADAS',
    codigo: 'E108',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS INSULINO-DEPENDENTE - SEM COMPLICAÇÕES',
    codigo: 'E109',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE',
    codigo: 'E11',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMA',
    codigo: 'E110',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM CETOACIDOSE',
    codigo: 'E111',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES RENAIS',
    codigo: 'E112',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES OFTÁLMICAS',
    codigo: 'E113',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES NEUROLÓGICAS',
    codigo: 'E114',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES CIRCULATÓRIAS PERIFÉRICAS',
    codigo: 'E115',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM OUTRAS COMPLICAÇÕES ESPECIFICADAS',
    codigo: 'E116',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES MÚLTIPLAS',
    codigo: 'E117',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - COM COMPLICAÇÕES NÃO ESPECIFICADAS',
    codigo: 'E118',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO-INSULINO-DEPENDENTE - SEM COMPLICAÇÕES',
    codigo: 'E119',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO',
    codigo: 'E14',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMA',
    codigo: 'E140',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM CETOACIDOSE',
    codigo: 'E141',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES RENAIS',
    codigo: 'E142',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES OFTÁLMICAS',
    codigo: 'E143',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES NEUROLÓGICAS',
    codigo: 'E144',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES CIRCULATÓRIAS PERIFÉRICAS',
    codigo: 'E145',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM OUTRAS COMPLICAÇÕES ESPECIFICADAS',
    codigo: 'E146',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES MÚLTIPLAS',
    codigo: 'E147',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - COM COMPLICAÇÕES NÃO ESPECIFICADAS',
    codigo: 'E148',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NÃO ESPECIFICADO - SEM COMPLICAÇÕES',
    codigo: 'E149',
    id_grupo: 'DIABETES',
  },
  { nm: null, nome: 'ENFISEMA', codigo: 'J43', id_grupo: 'DPOC' },
  { nm: null, nome: 'SÍNDROME DE MACLEOD', codigo: 'J430', id_grupo: 'DPOC' },
  { nm: null, nome: 'ENFISEMA PANLOBULAR', codigo: 'J431', id_grupo: 'DPOC' },
  {
    nm: null,
    nome: 'ENFISEMA CENTROLOBULAR',
    codigo: 'J432',
    id_grupo: 'DPOC',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE ENFISEMA',
    codigo: 'J438',
    id_grupo: 'DPOC',
  },
  {
    nm: null,
    nome: 'ENFISEMA NÃO ESPECIFICADO',
    codigo: 'J439',
    id_grupo: 'DPOC',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS PULMONARES OBSTRUTIVAS CRÔNICAS',
    codigo: 'J44',
    id_grupo: 'DPOC',
  },
  {
    nm: null,
    nome: 'DOENÇA PULMONAR OBSTRUTIVA CRÔNICA COM INFECÇÃO RESPIRATÓRIA AGUDA DO TRATO RESPIRATÓRIO INFERIOR',
    codigo: 'J440',
    id_grupo: 'DPOC',
  },
  {
    nm: null,
    nome: 'DOENÇA PULMONAR OBSTRUTIVA CRÔNICA COM EXACERBAÇÃO AGUDA NÃO ESPECIFICADA',
    codigo: 'J441',
    id_grupo: 'DPOC',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS ESPECIFICADAS DE DOENÇA PULMONAR OBSTRUTIVA CRÔNICA',
    codigo: 'J448',
    id_grupo: 'DPOC',
  },
  {
    nm: null,
    nome: 'DOENÇA PULMONAR OBSTRUTIVA CRÔNICA NÃO ESPECIFICADA',
    codigo: 'J449',
    id_grupo: 'DPOC',
  },
  { nm: null, nome: 'SÍFILIS CONGÊNITA', codigo: 'A50', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'SÍFILIS CONGÊNITA PRECOCE SINTOMÁTICA',
    codigo: 'A500',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS CONGÊNITA PRECOCE, FORMA LATENTE',
    codigo: 'A501',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS CONGÊNITA PRECOCE NÃO ESPECIFICADA',
    codigo: 'A502',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OCULOPATIA SIFILÍTICA CONGÊNITA TARDIA',
    codigo: 'A503',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'NEUROSSÍFILIS CONGÊNITA TARDIA [NEUROSSÍFILIS JUVENIL]',
    codigo: 'A504',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS TARDIAS E SINTOMÁTICAS DA SÍFILIS CONGÊNITA',
    codigo: 'A505',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS CONGÊNITA TARDIA LATENTE',
    codigo: 'A506',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS CONGÊNITA TARDIA NÃO ESPECIFICADA',
    codigo: 'A507',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS CONGÊNITA NÃO ESPECIFICADA',
    codigo: 'A509',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'SÍFILIS PRECOCE', codigo: 'A51', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'SÍFILIS GENITAL PRIMÁRIA',
    codigo: 'A510',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'SÍFILIS ANAL PRIMÁRIA', codigo: 'A511', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'SÍFILIS PRIMÁRIA DE OUTRAS LOCALIZAÇÕES',
    codigo: 'A512',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS SECUNDÁRIA DA PELE E DAS MUCOSAS',
    codigo: 'A513',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE SÍFILIS SECUNDÁRIA',
    codigo: 'A514',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS PRECOCE LATENTE',
    codigo: 'A515',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS PRECOCE NÃO ESPECIFICADA',
    codigo: 'A519',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'SÍFILIS TARDIA', codigo: 'A52', id_grupo: 'DTS' },
  { nm: null, nome: 'SÍFILIS CARDIOVASCULAR', codigo: 'A520', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'NEUROSSÍFILIS SINTOMÁTICA',
    codigo: 'A521',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'NEUROSSÍFILIS ASSINTOMÁTICA',
    codigo: 'A522',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'NEUROSSÍFILIS NÃO ESPECIFICADA',
    codigo: 'A523',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE SÍFILIS TARDIA SINTOMÁTICA',
    codigo: 'A527',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'SÍFILIS TARDIA LATENTE', codigo: 'A528', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'SÍFILIS TARDIA NÃO ESPECIFICADA',
    codigo: 'A529',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS E AS NÃO ESPECIFICADAS DA SÍFILIS',
    codigo: 'A53',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS LATENTE, NÃO ESPECIFICADA SE RECENTE OU TARDIA',
    codigo: 'A530',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'SÍFILIS NÃO ESPECIFICADA',
    codigo: 'A539',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'INFECÇÃO GONOCÓCICA', codigo: 'A54', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'INFECÇÃO GONOCÓCICA DO TRATO GENITUR. INFERIOR, SEM ABSCESSO PERIURETRAL OU DAS GLÂNDULAS ACESSÓRIAS',
    codigo: 'A540',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO GONOCÓCICA DO TRATO GENITUR. INFERIOR, COM ABSCESSO PERIURETRAL OU DAS GLÂNDULAS ACESSÓRIAS',
    codigo: 'A541',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'PELVIPERITONITE GONOCÓCICA E OUTRAS INFECÇÕES GENITURINÁRIAS GONOCÓCICAS',
    codigo: 'A542',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO GONOCÓCICA DO OLHO',
    codigo: 'A543',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO GONOCÓCICA DO SISTEMA MÚSCULO-ESQUELÉTICO',
    codigo: 'A544',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'FARINGITE GONOCÓCICA', codigo: 'A545', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'INFECÇÃO GONOCÓCICA DO ÂNUS OU DO RETO',
    codigo: 'A546',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES GONOCÓCICAS',
    codigo: 'A548',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO GONOCÓCICA NÃO ESPECIFICADA',
    codigo: 'A549',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'LINFOGRANULOMA (VENÉREO) POR CLAMÍDIA',
    codigo: 'A55',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES CAUSADAS POR CLAMÍDIAS TRANSMITIDAS POR VIA SEXUAL',
    codigo: 'A56',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÕES POR CLAMÍDIAS DO TRATO GENITURINÁRIO INFERIOR',
    codigo: 'A560',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO POR CLAMÍDIAS, PELVIPERITONIAL E DE OUTROS ÓRGÃOS GENITURINÁRIOS',
    codigo: 'A561',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO POR CLAMÍDIAS DO TRATO GENITURINÁRIO, LOCALIZAÇÃO NÃO ESPECIFICADA',
    codigo: 'A562',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DO ÂNUS E DO RETO POR CLAMÍDIAS',
    codigo: 'A563',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DA FARINGE POR CLAMÍDIAS',
    codigo: 'A564',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO POR CLAMÍDIAS TRANSMITIDA POR VIA SEXUAL, DE OUTRAS LOCALIZAÇÕES',
    codigo: 'A568',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'CANCRO MOLE', codigo: 'A57', id_grupo: 'DTS' },
  { nm: null, nome: 'GRANULOMA INGUINAL', codigo: 'A58', id_grupo: 'DTS' },
  { nm: null, nome: 'TRICOMONÍASE', codigo: 'A59', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'TRICOMONÍASE UROGENITAL',
    codigo: 'A590',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS LOCALIZAÇÕES DE TRICOMONÍASE',
    codigo: 'A598',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'TRICOMONÍASE NÃO ESPECIFICADA',
    codigo: 'A599',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÕES ANOGENITAIS PELO VÍRUS DO HERPES [HERPES SIMPLES]',
    codigo: 'A60',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DOS ÓRGÃOS GENITAIS E DO TRATO GENITURINÁRIO PELO VÍRUS DO HERPES',
    codigo: 'A600',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DA MARGEM CUTÂNEA DO ÂNUS E DO RETO PELO VÍRUS DO HERPES',
    codigo: 'A601',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO ANOGENITAL NÃO ESPECIFICADA PELO VÍRUS DO HERPES',
    codigo: 'A609',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS DE TRANSMISSÃO PREDOMINANTEMENTE SEXUAL, NÃO CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'A63',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'VERRUGAS ANOGENITAIS (VENÉREAS)',
    codigo: 'A630',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS ESPECIFICADAS DE TRANSMISSÃO PREDOMINANTEMENTE SEXUAL',
    codigo: 'A638',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'DOENÇAS SEXUALMENTE TRANSMITIDAS, NÃO ESPECIFICADAS',
    codigo: 'A64',
    id_grupo: 'DTS',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRE-EXISTENTE COMPLICANDO A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O10',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DISTURBIO HIPERTENSIVO PRE-EXISTENTE COM PROTEINURIA SUPERPOSTA',
    codigo: 'O11',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'EDEMA E PROTEINÚRIA GESTACIONAIS (INDUZIDOS PELA GRAVIDEZ) SEM HIPERTENSÃO',
    codigo: 'O12',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'EDEMA GESTACIONAL', codigo: 'O120', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'PROTEINÚRIA GESTACIONAL',
    codigo: 'O121',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'EDEMA GESTACIONAL COM PROTEINÚRIA',
    codigo: 'O122',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSAO GESTACIONAL (INDUZIDA PELA GRAVIDEZ) SEM PROTEINURIA SIGNIFICATIVA',
    codigo: 'O13',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO GESTACIONAL (INDUZIDA PELA GRAVIDEZ) COM PROTEINÚRIA SIGNIFICATIVA',
    codigo: 'O14',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PRÉ-ECLÂMPSIA MODERADA',
    codigo: 'O140',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PRÉ-ECLÂMPSIA GRAVE',
    codigo: 'O141',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PRÉ-ECLÂMPSIA NÃO ESPECIFICADA',
    codigo: 'O149',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'ECLAMPSIA', codigo: 'O15', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'ECLÂMPSIA NA GRAVIDEZ',
    codigo: 'O150',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ECLÂMPSIA NO TRABALHO DE PARTO',
    codigo: 'O151',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ECLÂMPSIA NÃO ESPECIFICADA QUANTO AO PERÍODO',
    codigo: 'O159',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSAO MATERNA NAO ESPECIFICADA',
    codigo: 'O16',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA DO INÍCIO DA GRAVIDEZ',
    codigo: 'O20',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'AMEAÇA DE ABORTO', codigo: 'O200', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'OUTRAS HEMORRAGIAS DO INÍCIO DA GRAVIDEZ',
    codigo: 'O208',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA DO INÍCIO DA GRAVIDEZ, NÃO ESPECIFICADA',
    codigo: 'O209',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VOMITOS EXCESSIVOS NA GRAVIDEZ',
    codigo: 'O21',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERÊMESE GRAVÍDICA LEVE',
    codigo: 'O210',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERÊMESE GRAVÍDICA COM DISTÚRBIO METABÓLICO',
    codigo: 'O211',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VÔMITOS TARDIOS DA GRAVIDEZ',
    codigo: 'O212',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE VÔMITOS COMPLICANDO A GRAVIDEZ',
    codigo: 'O218',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VÔMITOS DA GRAVIDEZ, NÃO ESPECIFICADOS',
    codigo: 'O219',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NA GRAVIDEZ',
    codigo: 'O22',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VARIZES DOS MEMBROS INFERIORES NA GRAVIDEZ',
    codigo: 'O220',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'VARIZES GENITAIS NA GRAVIDEZ',
    codigo: 'O221',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TROMBOFLEBITE SUPERFICIAL NA GRAVIDEZ',
    codigo: 'O222',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FLEBOTROMBOSE PROFUNDA NA GRAVIDEZ',
    codigo: 'O223',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRÓIDAS NA GRAVIDEZ',
    codigo: 'O224',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TROMBOSE VENOSA CEREBRAL NA GRAVIDEZ',
    codigo: 'O225',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES VENOSAS NA GRAVIDEZ',
    codigo: 'O228',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NA GRAVIDEZ, NÃO ESPECIFICADAS',
    codigo: 'O229',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DO TRATO GENITURINÁRIO NA GRAVIDEZ',
    codigo: 'O23',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DO RIM NA GRAVIDEZ',
    codigo: 'O230',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DA BEXIGA NA GRAVIDEZ',
    codigo: 'O231',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DA URETRA NA GRAVIDEZ',
    codigo: 'O232',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DE OUTRAS PARTES DO TRATO URINÁRIO NA GRAVIDEZ',
    codigo: 'O233',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÃO NÃO ESPECIFICADA DO TRATO URINÁRIO NA GRAVIDEZ',
    codigo: 'O234',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'INFECÇÕES DO TRATO GENITAL NA GRAVIDEZ',
    codigo: 'O235',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES E AS NÃO ESPECIFICADAS DO TRATO URINÁRIO NA GRAVIDEZ',
    codigo: 'O239',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NA GRAVIDEZ',
    codigo: 'O24',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, INSULINO-DEPENDENTE',
    codigo: 'O240',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, NÃO-INSULINO-DEPENDENTE',
    codigo: 'O241',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, RELACIONADO COM A DESNUTRIÇÃO',
    codigo: 'O242',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS PRÉ-EXISTENTE, NÃO ESPECIFICADO',
    codigo: 'O243',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS QUE SURGE DURANTE A GRAVIDEZ',
    codigo: 'O244',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES MELLITUS NA GRAVIDEZ, NÃO ESPECIFICADO',
    codigo: 'O249',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DESNUTRICAO NA GRAVIDEZ',
    codigo: 'O25',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES LIGADAS PREDOMINANTEMENTE A GRAVIDEZ',
    codigo: 'O26',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GANHO EXCESSIVO DE PESO NA GRAVIDEZ',
    codigo: 'O260',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GANHO DE PESO INSUFICIENTE NA GRAVIDEZ',
    codigo: 'O261',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'RETENÇÃO DE DISPOSITIVO INTRA-UTERINO CONTRACEPTIVO (DIU) NA GRAVIDEZ',
    codigo: 'O263',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HERPES GESTACIONAL',
    codigo: 'O264',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SÍNDROME DA HIPOTENSÃO MATERNA',
    codigo: 'O265',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES ESPECIFICADAS, LIGADAS A GRAVIDEZ',
    codigo: 'O268',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'AFECÇÕES LIGADAS A GRAVIDEZ, NÃO ESPECIFICADAS',
    codigo: 'O269',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS ANORMAIS DO RASTREAMENTO (SCREENING) ANTENATAL DA MÃE',
    codigo: 'O28',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS HEMATOLÓGICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O280',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS BIOQUÍMICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O281',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS CITOLÓGICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O282',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS ULTRASSONOGRÁFICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O283',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS RADIOLÓGICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O284',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS CROMOSSÔMICOS E GENÉTICOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O285',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTROS ACHADOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE',
    codigo: 'O288',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ACHADOS ANORMAIS DO RASTREAMENTO [SCREENING] ANTENATAL DA MÃE, NÃO ESPECIFICADOS',
    codigo: 'O289',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES DE ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O29',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES PULMONARES DE ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O290',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES CARDÍACAS DE ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O291',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES RELATIVAS AO SISTEMA NERVOSO CENTRAL DEVIDA A ANESTESIA ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O292',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'REAÇÃO TÓXICA CAUSADA POR ANESTESIA LOCAL ADMINISTRADA DURANTE A GRAVIDEZ',
    codigo: 'O293',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'CEFALÉIA CAUSADA POR ANESTESIA RAQUIDIANA OU PERIDURAL ADMINISTRADAS DURANTE A GRAVIDEZ',
    codigo: 'O294',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DE ANESTESIA RAQUIDIANA OU PERIDURAL ADMINISTRADAS DURANTE A GRAVIDEZ',
    codigo: 'O295',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALHA OU DIFICULDADE NA ENTUBAÇÃO DURANTE A GRAVIDEZ',
    codigo: 'O296',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DE ANESTESIA DURANTE A GRAVIDEZ',
    codigo: 'O298',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES DE ANESTESIA DURANTE A GRAVIDEZ, NÃO ESPECIFICADAS',
    codigo: 'O299',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'GESTAÇÃO MULTIPLA', codigo: 'O30', id_grupo: 'GRAVIDEZ' },
  { nm: null, nome: 'GRAVIDEZ DUPLA', codigo: 'O300', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'GRAVIDEZ TRIGEMELAR',
    codigo: 'O301',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ QUADRIGEMELAR',
    codigo: 'O302',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS GESTAÇÕES MÚLTIPLAS',
    codigo: 'O308',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GESTAÇÃO MÚLTIPLA, NÃO ESPECIFICADA',
    codigo: 'O309',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES ESPECIFICAS DE GESTAÇÃO MULTIPLA',
    codigo: 'O31',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'CONTINUAÇÃO DA GRAVIDEZ APÓS ABORTO DE UM OU MAIS FETOS',
    codigo: 'O311',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'CONTINUAÇÃO DA GRAVIDEZ APÓS A MORTE INTRA-UTERINA DE UM OU MAIS FETOS',
    codigo: 'O312',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES ESPECÍFICAS DE GESTAÇÃO MÚLTIPLA',
    codigo: 'O318',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR MOTIVO DE APRESENTAÇÃO ANORMAL CONHECIDA OU SUSPEITADA DO FETO',
    codigo: 'O32',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR POSIÇÃO FETAL INSTÁVEL',
    codigo: 'O320',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO PÉLVICA',
    codigo: 'O321',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR POSIÇÃO FETAL TRANSVERSA E OBLÍQUA',
    codigo: 'O322',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO DE FACE, MENTO E FRONTE',
    codigo: 'O323',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR POLO CEFÁLICO ALTO EM GESTAÇÃO A TERMO',
    codigo: 'O324',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR GESTAÇÃO MÚLTIPLA COM APRESENTAÇÃO ANORMAL DE UM OU MAIS FETOS',
    codigo: 'O325',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO COMPOSTA',
    codigo: 'O326',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS FORMAS DE APRESENTAÇÃO ANORMAL DO FETO',
    codigo: 'O328',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR APRESENTAÇÃO ANORMAL DO FETO, NÃO ESPECIFICADA',
    codigo: 'O329',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR UMA DESPROPORÇÃO CONHECIDA OU SUSPEITA',
    codigo: 'O33',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À DEFORMIDADE DA PELVE ÓSSEA MATERNA',
    codigo: 'O330',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À CONTRAÇÃO GERAL DA PELVE',
    codigo: 'O331',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À CONTRAÇÃO DO ESTREITO SUPERIOR DA PELVE',
    codigo: 'O332',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA À CONTRAÇÃO DO ESTREITO INFERIOR DA PELVE',
    codigo: 'O333',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DE ORIGEM MISTA, MATERNA E FETAL',
    codigo: 'O334',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA A FETO EXCEPCIONALMENTE GRANDE',
    codigo: 'O335',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA A FETO HIDROCEFÁLICO',
    codigo: 'O336',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DEVIDA A OUTRAS DEFORMIDADES FETAIS',
    codigo: 'O337',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO DE OUTRA ORIGEM',
    codigo: 'O338',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR UMA DESPROPORÇÃO, NÃO ESPECIFICADA',
    codigo: 'O339',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR ANORMALIDADE CONHECIDA OU SUSPEITA DOS ORGÃOS PÉLVICOS MATERNOS',
    codigo: 'O34',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA À MÃE POR MALFORMAÇÃO CONGÊNITA DO ÚTERO',
    codigo: 'O340',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR TUMOR DO CORPO DO ÚTERO',
    codigo: 'O341',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR CICATRIZ UTERINA DEVIDA A UMA CIRURGIA ANTERIOR',
    codigo: 'O342',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR INCOMPETÊNCIA CERVICAL',
    codigo: 'O343',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES DO COLO DO ÚTERO',
    codigo: 'O344',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES DO ÚTERO GRAVÍDICO',
    codigo: 'O345',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE DA VAGINA',
    codigo: 'O346',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE DA VULVA E DO PERÍNEO',
    codigo: 'O347',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES DOS ÓRGÃOS PÉLVICOS',
    codigo: 'O348',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE DE ÓRGÃOS PÉLVICOS, NÃO ESPECIFICADA',
    codigo: 'O349',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR ANORMALIDADE E LESÃO FETAIS CONHECIDAS OU SUSPEITADAS',
    codigo: 'O35',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR MALFORMAÇÃO DO SISTEMA NERVOSO CENTRAL DO FETO (SUSPEITADA)',
    codigo: 'O350',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ANORMALIDADE CROMOSSÔMICA (SUSPEITADA) DO FETO',
    codigo: 'O351',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR DOENÇA HEREDITÁRIA (SUSPEITADA) DO FETO',
    codigo: 'O352',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR DOENÇA VIRAL MATERNA',
    codigo: 'O353',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO (SUSPEITADA) CAUSADA AO FETO POR ALCOOLISMO MATERNO',
    codigo: 'O354',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR DROGAS',
    codigo: 'O355',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR RADIAÇÃO',
    codigo: 'O356',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO FETAL (SUSPEITADA) CAUSADA POR OUTROS PROCEDIMENTOS MÉDICOS',
    codigo: 'O357',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTRAS ANORMALIDADES OU LESÕES FETAIS (SUSPEITADAS)',
    codigo: 'O358',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR LESÃO OU ANORMALIDADE FETAIS (SUSPEITADAS), NÃO ESPECIFICADAS',
    codigo: 'O359',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA A MÃE POR OUTROS PROBLEMAS FETAIS CONHECIDOS OU SUSPEITADOS',
    codigo: 'O36',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR ISOIMUNIZAÇÃO RH',
    codigo: 'O360',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTROS TIPOS DE ISOIMUNIZAÇÃO',
    codigo: 'O361',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR HIDROPSIA FETAL',
    codigo: 'O362',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR SINAIS DE HIPÓXIA FETAL',
    codigo: 'O363',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR INSUFICIÊNCIA DE CRESCIMENTO FETAL',
    codigo: 'O365',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR CRESCIMENTO FETAL EXCESSIVO',
    codigo: 'O366',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR FETO VIÁVEL EM GRAVIDEZ ABDOMINAL',
    codigo: 'O367',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR OUTROS PROBLEMAS FETAIS ESPECIFICADOS',
    codigo: 'O368',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA PRESTADA À MÃE POR PROBLEMA FETAL NÃO ESPECIFICADO',
    codigo: 'O369',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'POLI-HIDRAMNIO', codigo: 'O40', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'TRANSTORNOS DAS MEMBRANAS E DO LÍQUIDO AMNIÓTICO',
    codigo: 'O41',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'OLIGOHIDRÂMNIO', codigo: 'O410', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'INFECÇÃO DO SACO AMNIÓTICO E DAS MEMBRANAS',
    codigo: 'O411',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECIFICADOS DO LÍQUIDO AMNIÓTICO E DAS MEMBRANAS',
    codigo: 'O418',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DO LÍQUIDO AMNIÓTICO E DAS MEMBRANAS NÃO ESPECIFICADOS',
    codigo: 'O419',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA PLACENTA',
    codigo: 'O43',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SÍNDROMES DE TRANSFUSÃO PLACENTÁRIA',
    codigo: 'O430',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'MALFORMAÇÃO DA PLACENTA',
    codigo: 'O431',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA PLACENTA',
    codigo: 'O438',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DA PLACENTA, NÃO ESPECIFICADO',
    codigo: 'O439',
    id_grupo: 'GRAVIDEZ',
  },
  { nm: null, nome: 'PLACENTA PREVIA', codigo: 'O44', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'PLACENTA PRÉVIA ESPECIFICADA COMO SEM HEMORRAGIA',
    codigo: 'O440',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PLACENTA PRÉVIA COM HEMORRAGIA',
    codigo: 'O441',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA ANTEPARTO NÃO CLASSIFICADA EM OUTRA PARTE',
    codigo: 'O46',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA ANTEPARTO COM DEFICIÊNCIA DE COAGULAÇÃO',
    codigo: 'O460',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRA FORMA DE HEMORRAGIA ANTEPARTO',
    codigo: 'O468',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA ANTEPARTO, NÃO ESPECIFICADA',
    codigo: 'O469',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO',
    codigo: 'O47',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO ANTES DE SE COMPLETAREM 37 SEMANAS DE GESTAÇÃO',
    codigo: 'O470',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO NA 37ª SEMANA COMPLETA OU DEPOIS DELA',
    codigo: 'O471',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FALSO TRABALHO DE PARTO, NÃO ESPECIFICADO',
    codigo: 'O479',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ PROLONGADA',
    codigo: 'O48',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'FEBRE DURANTE O TRABALHO DE PARTO NÃO CLASSIFICADA EM OUTRA PARTE',
    codigo: 'O752',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES DURANTE O TRABALHO DE PARTO',
    codigo: 'O753',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇA INFECCIOSA PARASITÁRIA MATERNA COP MAS QUE COMPLIQUEM A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O98',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'ANEMIA COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O990',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS DO SANGUE E DOS ÓRGÃOS HEMATOP. E ALGUNS TRANST. QUE COMPROMETEM O SIST. IMUNOLÓGICO',
    codigo: 'O991',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS ENDÓCRINAS, NUTRICIONAIS E METABÓLICAS COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O992',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E DOENÇAS DO SISTEMA NERVOSO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O993',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DO APARELHO CIRCULATÓRIO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O994',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DO APARELHO RESPIRATÓRIO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O995',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DO APARELHO DIGESTIVO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O996',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇAS DA PELE E DO TECIDO SUBCUTÂNEO COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O997',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ CONFIRMADA',
    codigo: 'Z321',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ COMO ACHADO CASUAL',
    codigo: 'Z33',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ NORMAL',
    codigo: 'Z34',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE PRIMEIRA GRAVIDEZ NORMAL',
    codigo: 'Z340',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE OUTRA GRAVIDEZ NORMAL',
    codigo: 'Z348',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ NORMAL, NÃO ESPECIFICADA',
    codigo: 'Z349',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ DE ALTO RISCO',
    codigo: 'Z35',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM HISTÓRIA DE ESTERILIDADE',
    codigo: 'Z350',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM HISTÓRIA DE ABORTO',
    codigo: 'Z351',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM OUTROS ANTECEDENTES DE PROCRIAÇÃO PROBLEMÁTICA',
    codigo: 'Z352',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM HISTÓRIA DE ASSISTÊNCIA PRÉ-NATAL INSUFICIENTE',
    codigo: 'Z353',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ COM GRANDE MULTIPARIDADE',
    codigo: 'Z354',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE GRAVIDEZ DE ALTO RISCO DEVIDO A PROBLEMAS SOCIAIS',
    codigo: 'Z357',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE OUTRAS GRAVIDEZES DE ALTO RISCO',
    codigo: 'Z358',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO NÃO ESPECIFICADA DE GRAVIDEZ DE ALTO RISCO',
    codigo: 'Z359',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'RASTREAMENTO (SCREENING) PRÉ-NATAL',
    codigo: 'Z36',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'PROBLEMAS RELACIONADOS COM UMA GRAVIDEZ NÃO DESEJADA',
    codigo: 'Z640',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DOENÇA DE HANSEN (LEPRA)',
    codigo: 'A30',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HANSENÍASE [LEPRA] INDETERMINADA',
    codigo: 'A300',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HANSENÍASE [LEPRA] TUBERCULÓIDE',
    codigo: 'A301',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HANSENÍASE [LEPRA] TUBERCULÓIDE BORDERLINE',
    codigo: 'A302',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HANSENÍASE [LEPRA] DIMORFA',
    codigo: 'A303',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HANSENÍASE [LEPRA] LEPROMATOSA BORDERLINE',
    codigo: 'A304',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HANSENÍASE [LEPRA] LEPROMATOSA',
    codigo: 'A305',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE HANSENÍASE [LEPRA]',
    codigo: 'A308',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HANSENÍASE [LEPRA] NÃO ESPECIFICADA',
    codigo: 'A309',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE HANSENÍASE [LEPRA]',
    codigo: 'B92',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO ESSENCIAL (PRIMÁRIA)',
    codigo: 'I10',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA',
    codigo: 'I11',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA COM INSUFICIÊNCIA CARDÍACA (CONGESTIVA)',
    codigo: 'I110',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA SEM INSUFICIÊNCIA CARDÍACA (CONGESTIVA)',
    codigo: 'I119',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA',
    codigo: 'I12',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA COM INSUFICIÊNCIA RENAL',
    codigo: 'I120',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA SEM INSUFICIÊNCIA RENAL',
    codigo: 'I129',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA',
    codigo: 'I13',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA COM INSUFICIÊNCIA CARDÍACA (CONGESTIVA)',
    codigo: 'I130',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA COM INSUFICIÊNCIA RENAL',
    codigo: 'I131',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA COM INSUFICIÊNCIA CARDÍACA (CONGESTIVA) E INSUFICIÊNCIA RENAL',
    codigo: 'I132',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA, NÃO ESPECIFICADA',
    codigo: 'I139',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA',
    codigo: 'I15',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO RENOVASCULAR',
    codigo: 'I150',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA A OUTRAS AFECÇÕES RENAIS',
    codigo: 'I151',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA A AFECÇÕES ENDÓCRINAS',
    codigo: 'I152',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE HIPERTENSÃO SECUNDÁRIA',
    codigo: 'I158',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA, NÃO ESPECIFICADA',
    codigo: 'I159',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRE-EXISTENTE COMPLICANDO A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O10',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO ESSENCIAL PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O100',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O101',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O102',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O103',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O104',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRÉ-EXISTENTE NÃO ESPECIFICADA, COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O109',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'DISTURBIO HIPERTENSIVO PRE-EXISTENTE COM PROTEINURIA SUPERPOSTA',
    codigo: 'O11',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I21',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO AGUDO TRANSMURAL DA PAREDE ANTERIOR DO MIOCÁRDIO',
    codigo: 'I210',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO AGUDO TRANSMURAL DA PAREDE INFERIOR DO MIOCÁRDIO',
    codigo: 'I211',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO AGUDO TRANSMURAL DO MIOCÁRDIO DE OUTRAS LOCALIZAÇÕES',
    codigo: 'I212',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO AGUDO TRANSMURAL DO MIOCÁRDIO, DE LOCALIZAÇÃO NÃO ESPECIFICADA',
    codigo: 'I213',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO AGUDO SUBENDOCÁRDICO DO MIOCÁRDIO',
    codigo: 'I214',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO AGUDO DO MIOCÁRDIO NÃO ESPECIFICADO',
    codigo: 'I219',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO DO MIOCÁRDIO RECORRENTE DA PAREDE ANTERIOR',
    codigo: 'I220',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO DO MIOCÁRDIO RECORRENTE DA PAREDE INFERIOR',
    codigo: 'I221',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO DO MIOCÁRDIO RECORRENTE DE OUTRAS LOCALIZAÇÕES',
    codigo: 'I228',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'INFARTO DO MIOCÁRDIO RECORRENTE DE LOCALIZAÇÃO NÃO ESPECIFICADA',
    codigo: 'I229',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'HEMOPERICÁRDIO COMO COMPLICAÇÃO ATUAL SUBSEQÜENTE AO INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I230',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'COMUNICAÇÃO INTERATRIAL COMO COMPLICAÇÃO ATUAL SUBSEQÜENTE AO INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I231',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'COMUNICAÇÃO INTERVENTRICULAR COMO COMPLICAÇÃO ATUAL SUBSEQÜENTE AO INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I232',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'RUPTURA PAREDE CORAÇÃO SEM OCORR. HEMOPERICÁRDIO COMO COMPLIC. ATUAL SUBSEQ. INFARTO AGUDO MIOCÁRDIO',
    codigo: 'I233',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'RUPTURA DE CORDOALHAS TENDÍNEAS COMO COMPLICAÇÃO ATUAL SUBSEQÜENTE AO INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I234',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'RUPTURA DE MÚSCULOS PAPILARES COMO COMPLICAÇÃO ATUAL SUBSEQÜENTE AO INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I235',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'TROMBOSE DE ÁTRIO, AURÍCULA E VENTRÍCULO COMO COMPLICAÇÃO ATUAL SUBSEQ. INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I236',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES ATUAIS SUBSEQÜENTES AO INFARTO AGUDO DO MIOCÁRDIO',
    codigo: 'I238',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'SÍNDROME DE DRESSLER',
    codigo: 'I241',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'FLUTTER E FIBRILAÇÃO ATRIAL',
    codigo: 'I48',
    id_grupo: 'INFARTO',
  },
  { nm: null, nome: 'OBESIDADE', codigo: 'E66', id_grupo: 'OBESIDADE' },
  {
    nm: null,
    nome: 'OBESIDADE DEVIDA A EXCESSO DE CALORIAS',
    codigo: 'E660',
    id_grupo: 'OBESIDADE',
  },
  {
    nm: null,
    nome: 'OBESIDADE INDUZIDA POR DROGAS',
    codigo: 'E661',
    id_grupo: 'OBESIDADE',
  },
  {
    nm: null,
    nome: 'OBESIDADE EXTREMA COM HIPOVENTILAÇÃO ALVEOLAR',
    codigo: 'E662',
    id_grupo: 'OBESIDADE',
  },
  { nm: null, nome: 'OUTRA OBESIDADE', codigo: 'E668', id_grupo: 'OBESIDADE' },
  {
    nm: null,
    nome: 'OBESIDADE NÃO ESPECIFICADA',
    codigo: 'E669',
    id_grupo: 'OBESIDADE',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS ASSOCIADOS AO PUERPÉRIO NÃO CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F53',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS LEVES ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F530',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS GRAVES ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F531',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS MENTAIS E COMPORTAMENTAIS ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F538',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MENTAL E COMPORTAMENTAL ASSOCIADO AO PUERPÉRIO, NÃO ESPECIFICADO',
    codigo: 'F539',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OSTEOMALÁCIA PUERPERAL',
    codigo: 'M830',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRE-EXISTENTE COMPLICANDO A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O10',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO ESSENCIAL PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O100',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O101',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O102',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA CARDÍACA E RENAL HIPERTENSIVA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O103',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SECUNDÁRIA PRÉ-EXISTENTE COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O104',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO PRÉ-EXISTENTE NÃO ESPECIFICADA, COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O109',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ECLÂMPSIA NO PUERPÉRIO',
    codigo: 'O152',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DO FÍGADO NA GRAVIDEZ, NO PARTO E NO PUERPÉRIO',
    codigo: 'O266',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HEMORRAGIAS PÓS-PARTO, TARDIAS E SECUNDÁRIAS',
    codigo: 'O722',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIAS DE COAGULAÇÃO PÓS-PARTO',
    codigo: 'O723',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'INFECCAO PUERPERAL', codigo: 'O85', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES PUERPERAIS',
    codigo: 'O86',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DA INCISÃO CIRÚRGICA DE ORIGEM OBSTÉTRICA',
    codigo: 'O860',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES DOS ÓRGÃOS GENITAIS SUBSEQÜENTES AO PARTO',
    codigo: 'O861',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DAS VIAS URINÁRIAS SUBSEQÜENTES AO PARTO',
    codigo: 'O862',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES DAS VIAS GENITOURINÁRIAS SUBSEQÜENTES AO PARTO',
    codigo: 'O863',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'FEBRE DE ORIGEM DESCONHECIDA SUBSEQÜENTE AO PARTO',
    codigo: 'O864',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS INFECÇÕES PUERPERAIS ESPECIFICADAS',
    codigo: 'O868',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NO PUERPÉRIO',
    codigo: 'O87',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TROMBOFLEBITE SUPERFICIAL NO PUERPÉRIO',
    codigo: 'O870',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TROMBOFLEBITE PROFUNDA NO PUERPÉRIO',
    codigo: 'O871',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HEMORRÓIDAS NO PUERPÉRIO',
    codigo: 'O872',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TROMBOSE VENOSA CEREBRAL NO PUERPÉRIO',
    codigo: 'O873',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES VENOSAS NO PUERPÉRIO',
    codigo: 'O878',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES VENOSAS NO PUERPÉRIO, NÃO ESPECIFICADAS',
    codigo: 'O879',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÕES DO PUERPÉRIO NÃO CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'O90',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'RUPTURA DA INCISÃO DE CESARIANA',
    codigo: 'O900',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'RUPTURA DA INCISÃO OBSTÉTRICA, NO PERÍNEO',
    codigo: 'O901',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'HEMATOMA DA INCISÃO OBSTÉTRICA',
    codigo: 'O902',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'CARDIOMIOPATIA NO PUERPÉRIO',
    codigo: 'O903',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INSUFICIÊNCIA RENAL AGUDA DO PÓS-PARTO',
    codigo: 'O904',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'TIREOIDITE DO PÓS-PARTO',
    codigo: 'O905',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DO PUERPÉRIO, NÃO CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'O908',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'COMPLICAÇÃO DO PUERPÉRIO NÃO ESPECIFICADA',
    codigo: 'O909',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÕES MAMÁRIAS ASSOCIADAS AO PARTO',
    codigo: 'O91',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DO MAMILO ASSOCIADA AO PARTO',
    codigo: 'O910',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ABSCESSO DA MAMA ASSOCIADA AO PARTO',
    codigo: 'O911',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'MASTITE NÃO PURULENTA ASSOCIADA AO PARTO',
    codigo: 'O912',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES DA MAMA E DA LACTAÇÃO ASSOCIADAS AO PARTO',
    codigo: 'O92',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'MAMILO RETRAÍDO ASSOCIADO AO PARTO',
    codigo: 'O920',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'FISSURAS DO MAMILO ASSOCIADAS AO PARTO',
    codigo: 'O921',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES DA MAMA, E AS NÃO ESPECIFICADAS, ASSOCIADAS AO PARTO',
    codigo: 'O922',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'AGALACTIA', codigo: 'O923', id_grupo: 'PARTO' },
  { nm: null, nome: 'HIPOGALACTIA', codigo: 'O924', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'SUSPENSÃO DA LACTAÇÃO',
    codigo: 'O925',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'GALACTORRÉIA', codigo: 'O926', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'OUTROS DISTÚRBIOS DA LACTAÇÃO E OS NÃO ESPECIFICADOS',
    codigo: 'O927',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE COMPLICAÇÕES DA GRAVIDEZ, PARTO E PUERPÉRIO',
    codigo: 'O94',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇA INFECCIOSA PARASITÁRIA MATERNA COP MAS QUE COMPLIQUEM A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O98',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'DOENÇAS DA MÃE CLASSIFICADAS EM OUTRA PARTEMAS QUE COMPLICAM A GRAVIDEZ O PARTO E O PUERPÉRIO',
    codigo: 'O99',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS E AFECÇÕES ESPECIFICADAS COMPLICANDO A GRAVIDEZ, O PARTO E O PUERPÉRIO',
    codigo: 'O998',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA E EXAME PÓS-NATAL',
    codigo: 'Z39',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'ASSISTÊNCIA E EXAME DA MÃE NUTRIZ',
    codigo: 'Z391',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SEGUIMENTO PÓS-PARTO DE ROTINA',
    codigo: 'Z392',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'REABILITAÇÃO CARDÍACA',
    codigo: 'Z500',
    id_grupo: 'REABILITACAO',
  },
  {
    nm: null,
    nome: 'OUTRA FISIOTERAPIA',
    codigo: 'Z501',
    id_grupo: 'REABILITACAO',
  },
  {
    nm: null,
    nome: 'REABILITAÇÃO DA LINGUAGEM',
    codigo: 'Z505',
    id_grupo: 'REABILITACAO',
  },
  {
    nm: null,
    nome: 'TREINAMENTO ORTÓPTICO',
    codigo: 'Z506',
    id_grupo: 'REABILITACAO',
  },
  {
    nm: null,
    nome: 'TERAPIA OCUPACIONAL E REABILITAÇÃO VOCACIONAL NÃO CLASSIFICADA EM OUTRA PARTE',
    codigo: 'Z507',
    id_grupo: 'REABILITACAO',
  },
  {
    nm: null,
    nome: 'INFECÇÕES POR CLAMÍDIAS DO TRATO GENITURINÁRIO INFERIOR',
    codigo: 'A560',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO POR CLAMÍDIAS DO TRATO GENITURINÁRIO, LOCALIZAÇÃO NÃO ESPECIFICADA',
    codigo: 'A562',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'TRICOMONÍASE UROGENITAL',
    codigo: 'A590',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CANDIDÍASE DE OUTRAS LOCALIZAÇÕES UROGENITAIS',
    codigo: 'B374',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA MALIGNA DO RIM, EXCETO PELVE RENAL',
    codigo: 'C64',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA MALIGNA DA PELVE RENAL',
    codigo: 'C65',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA MALIGNA DOS URETERES',
    codigo: 'C66',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA MALIGNA DA BEXIGA',
    codigo: 'C67',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA MALIGNA DE OUTROS ÓRGÃOS URINÁRIOS E DOS NÃO ESPECIFICADOS',
    codigo: 'C68',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CARCINOMA IN SITU DE OUTROS ÓRGÃOS URINÁRIOS E OS NÃO ESPECIFICADOS',
    codigo: 'D091',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CARCINOMA IN SITU, NÃO ESPECIFICADO',
    codigo: 'D099',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA BENIGNA DOS ÓRGÃOS URINÁRIOS',
    codigo: 'D30',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA DE COMPORTAMENTO INCERTO OU DESCONHECIDO DOS ÓRGÃOS URINÁRIOS',
    codigo: 'D41',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'SÍNDROME NEFRÍTICA AGUDA',
    codigo: 'N00',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'SÍNDROME NEFRÍTICA RAPIDAMENTE PROGRESSIVA',
    codigo: 'N01',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'SÍNDROME NEFRÍTICA CRÔNICA',
    codigo: 'N03',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'SÍNDROME NEFRÓTICA', codigo: 'N04', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'SÍNDROME NEFRÍTICA NÃO ESPECIFICADA',
    codigo: 'N05',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'PROTEINÚRIA ISOLADA COM LESÃO MORFOLÓGICA ESPECIFICADA',
    codigo: 'N06',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEFROPATIA HEREDITÁRIA NÃO CLASSIFICADA EM OUTRA PARTE',
    codigo: 'N07',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS GLOMERULARES EM DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'N08',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEFRITE TÚBULO-INTERSTICIAL AGUDA',
    codigo: 'N10',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEFRITE TÚBULO-INTERSTICIAL CRÔNICA',
    codigo: 'N11',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEFRITE TÚBULO-INTERSTICIAL NÃO ESPECIFICADA SE AGUDA OU CRÔNICA',
    codigo: 'N12',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'UROPATIA OBSTRUTIVA E POR REFLUXO',
    codigo: 'N13',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'AFECÇÕES TUBULARES E TÚBULO-INTERSTICIAIS INDUZIDAS POR DROGAS OU METAIS PESADOS',
    codigo: 'N14',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'NEFROPATIA DOS BÁLCÃS', codigo: 'N150', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'ABSCESSO RENAL E PERINEFRÉTICO',
    codigo: 'N151',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS RENAIS TÚBULO-INTERSTICIAIS ESPECIFICADAS',
    codigo: 'N158',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'DOENÇA RENAL TÚBULO-INTERSTICIAL NÃO ESPECIFICADA',
    codigo: 'N159',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS RENAIS TÚBULO-INTERSTICIAIS EM DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'N16',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'INSUFICIÊNCIA RENAL AGUDA',
    codigo: 'N17',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'INSUFICIÊNCIA RENAL CRÔNICA',
    codigo: 'N18',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'INSUFICIÊNCIA RENAL NÃO ESPECIFICADA',
    codigo: 'N19',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CALCULOSE DO RIM E DO URETER',
    codigo: 'N20',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CALCULOSE DO TRATO URINÁRIO INFERIOR',
    codigo: 'N21',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CALCULOSE DO TRATO URINÁRIO INFERIOR EM DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'N22',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS RESULTANTES DE FUNÇÃO RENAL TUBULAR ALTERADA',
    codigo: 'N25',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'RIM CONTRAÍDO, NÃO ESPECIFICADO',
    codigo: 'N26',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'HIPOPLASIA RENAL DE CAUSA DESCONHECIDA',
    codigo: 'N27',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO RIM E DO URETER NÃO CLASSIFICADO EM OUTRA PARTE',
    codigo: 'N28',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO RIM E DO URETER EM DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'N29',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'CISTITE', codigo: 'N30', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'DISFUNÇÕES NEUROMUSCULARES DA BEXIGA NÃO CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'N31',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA BEXIGA',
    codigo: 'N32',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA BEXIGA EM DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'N33',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'URETRITE E SÍNDROME URETRAL',
    codigo: 'N34',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'ESTENOSE DA URETRA', codigo: 'N35', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA URETRA',
    codigo: 'N36',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA URETRA EM DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'N37',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'INFECÇÃO DO TRATO URINÁRIO DE LOCALIZAÇÃO NÃO ESPECIFICADA',
    codigo: 'N390',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'PROTEINÚRIA PERSISTENTE NÃO ESPECIFICADA',
    codigo: 'N391',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'PROTEINÚRIA ORTOSTÁTICA NÃO ESPECIFICADA',
    codigo: 'N392',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECIFICADOS DO APARELHO URINÁRIO',
    codigo: 'N398',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'AGENESIA RENAL E OUTROS DEFEITOS DE REDUÇÃO DO RIM',
    codigo: 'Q60',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'DOENÇAS CÍSTICAS DO RIM',
    codigo: 'Q61',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'ANOMALIAS CONGÊNITAS OBSTRUTIVAS DA PELVE RENAL E MALFORMAÇÕES CONGÊNITAS DO URETER',
    codigo: 'Q62',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTRAS MALFORMAÇÕES CONGÊNITAS DO RIM',
    codigo: 'Q63',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTRAS MALFORMAÇÕES CONGÊNITAS DO APARELHO URINÁRIO',
    codigo: 'Q64',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'UREMIA EXTRA-RENAL', codigo: 'R392', id_grupo: 'RINS' },
  { nm: null, nome: 'PROTEINÚRIA ISOLADA', codigo: 'R80', id_grupo: 'RINS' },
  { nm: null, nome: 'GLICOSÚRIA', codigo: 'R81', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'OUTROS ACHADOS ANORMAIS NA URINA',
    codigo: 'R82',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'TRAUMATISMO DO RIM', codigo: 'S370', id_grupo: 'RINS' },
  { nm: null, nome: 'TRAUMATISMO DO URETER', codigo: 'S371', id_grupo: 'RINS' },
  { nm: null, nome: 'TRAUMATISMO DA BEXIGA', codigo: 'S372', id_grupo: 'RINS' },
  { nm: null, nome: 'TRAUMATISMO DA URETRA', codigo: 'S373', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'CORPO ESTRANHO NA URETRA',
    codigo: 'T190',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CORPO ESTRANHO NA BEXIGA',
    codigo: 'T191',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CORPO ESTRANHO EM OUTRAS PARTES E PARTES MÚLTIPLAS DO TRATO GENITURINÁRIO',
    codigo: 'T198',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'CORPO ESTRANHO NO TRATO GENITURINÁRIO, PARTE NÃO ESPECIFICADA',
    codigo: 'T199',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'QUEIMADURA DOS ÓRGÃOS GENITURINÁRIOS INTERNOS',
    codigo: 'T283',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'AUSÊNCIA ADQUIRIDA DO RIM',
    codigo: 'Z905',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'AUSÊNCIA ADQUIRIDA DE OUTRAS PARTES DO TRATO URINÁRIO',
    codigo: 'Z906',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA DE ALZHEIMER',
    codigo: 'F00',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA DE ALZHEIMER DE INÍCIO PRECOCE',
    codigo: 'F000',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA DE ALZHEIMER DE INÍCIO TARDIO',
    codigo: 'F001',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA DE ALZHEIMER, FORMA ATÍPICA OU MISTA',
    codigo: 'F002',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NÃO ESPECIFICADA NA DOENÇA DE ALZHEIMER',
    codigo: 'F009',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA VASCULAR',
    codigo: 'F01',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA VASCULAR DE INÍCIO AGUDO',
    codigo: 'F010',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA POR INFARTOS MÚLTIPLOS',
    codigo: 'F011',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA VASCULAR SUBCORTICAL',
    codigo: 'F012',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA VASCULAR MISTA, CORTICAL E SUBCORTICAL',
    codigo: 'F013',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRA DEMÊNCIA VASCULAR',
    codigo: 'F018',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA VASCULAR NÃO ESPECIFICADA',
    codigo: 'F019',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA EM OUTRAS DOENÇAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'F02',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA DA DOENÇA DE PICK',
    codigo: 'F020',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA DE CREUTZFELDT-JAKOB',
    codigo: 'F021',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA DE HUNTINGTON',
    codigo: 'F022',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA DE PARKINSON',
    codigo: 'F023',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NA DOENÇA PELO VÍRUS DA IMUNODEFICIÊNCIA HUMANA [HIV]',
    codigo: 'F024',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA EM OUTRAS DOENÇAS ESPECIFICADAS CLASSIFICADAS EM OUTRA PARTE',
    codigo: 'F028',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEMÊNCIA NÃO ESPECIFICADA',
    codigo: 'F03',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SÍNDROME AMNÉSICA ORGÂNICA NÃO INDUZIDA PELO ÁLCOOL OU POR OUTRAS SUBSTÂNCIAS PSICOATIVAS',
    codigo: 'F04',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DELIRIUM NÃO INDUZIDO PELO ÁLCOOL OU POR OUTRAS SUBSTÂNCIAS PSICOATIVAS',
    codigo: 'F05',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DELIRIUM NÃO SUPERPOSTO A UMA DEMÊNCIA, ASSIM DESCRITO',
    codigo: 'F050',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DELIRIUM SUPERPOSTO A UMA DEMÊNCIA',
    codigo: 'F051',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'OUTRO DELÍRIO', codigo: 'F058', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'DELIRIUM NÃO ESPECIFICADO',
    codigo: 'F059',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS MENTAIS DEVIDOS A LESÃO E DISFUNÇÃO CEREBRAL E A DOENÇA FÍSICA',
    codigo: 'F06',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ALUCINOSE ORGÂNICA',
    codigo: 'F060',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESTADO CATATÔNICO ORGÂNICO',
    codigo: 'F061',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DELIRANTE ORGÂNICO [TIPO ESQUIZOFRÊNICO]',
    codigo: 'F062',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DO HUMOR [AFETIVOS] ORGÂNICOS',
    codigo: 'F063',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA ANSIEDADE ORGÂNICOS',
    codigo: 'F064',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DISSOCIATIVO ORGÂNICO',
    codigo: 'F065',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE LABILIDADE EMOCIONAL [ASTÊNICO] ORGÂNICO',
    codigo: 'F066',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO COGNITIVO LEVE',
    codigo: 'F067',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS MENTAIS ESPECIF. DEVIDOS A UMA LESÃO E DISFUNÇÃO CEREBRAL E A UMA DOENÇA FÍSICA',
    codigo: 'F068',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MENTAL NÃO ESPECIFICADO DEVIDO A UMA LESÃO E DISFUNÇÃO CEREBRAL E A UMA DOENÇA FÍSICA',
    codigo: 'F069',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DE PERSONALIDADE E DO COMPORTAMENTO DEVIDOS A DOENÇA, A LESÃO E A DISFUNÇÃO CEREBRAL',
    codigo: 'F07',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ORGÂNICO DA PERSONALIDADE',
    codigo: 'F070',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SÍNDROME PÓS-ENCEFALÍTICA',
    codigo: 'F071',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SÍNDROME PÓS-TRAUMÁTICA',
    codigo: 'F072',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ORGÂNICOS DA PERSON. E COMPORT. DEVIDOS A DOENÇA CEREBRAL, LESÃO E DISFUNÇÃO',
    codigo: 'F078',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ORGÂNICO NÃO ESPECIF. DA PERSON. E COMPORT. DEVIDO A DOENÇA CEREBRAL, LESÃO E DISFUNÇÃO',
    codigo: 'F079',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MENTAL ORGÂNICO OU SINTOMÁTICO NÃO ESPECIFICADO',
    codigo: 'F09',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'ESQUIZOFRENIA', codigo: 'F20', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'ESQUIZOFRENIA PARANÓIDE',
    codigo: 'F200',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESQUIZOFRENIA HEBEFRÊNICA',
    codigo: 'F201',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESQUIZOFRENIA CATATÔNICA',
    codigo: 'F202',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESQUIZOFRENIA INDIFERENCIADA',
    codigo: 'F203',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DEPRESSÃO PÓS-ESQUIZOFRÊNICA',
    codigo: 'F204',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESQUIZOFRENIA RESIDUAL',
    codigo: 'F205',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESQUIZOFRENIA SIMPLES',
    codigo: 'F206',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRAS ESQUIZOFRENIAS',
    codigo: 'F208',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESQUIZOFRENIA NÃO ESPECIFICADA',
    codigo: 'F209',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESQUIZOTÍPICO',
    codigo: 'F21',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DELIRANTES PERSISTENTES',
    codigo: 'F22',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DELIRANTE',
    codigo: 'F220',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DELIRANTES PERSISTENTES',
    codigo: 'F228',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DELIRANTE PERSISTENTE NÃO ESPECIFICADO',
    codigo: 'F229',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS PSICÓTICOS AGUDOS E TRANSITÓRIOS',
    codigo: 'F23',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO PSICÓTICO AGUDO POLIMORFO, SEM SINTOMAS ESQUIZOFRÊNICOS',
    codigo: 'F230',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO PSICÓTICO AGUDO POLIMORFO, COM SINTOMAS ESQUIZOFRÊNICOS',
    codigo: 'F231',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO PSICÓTICO AGUDO DE TIPO ESQUIZOFRÊNICO (SCHIZOPHRENIA-LIKE)',
    codigo: 'F232',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS PSICÓTICOS AGUDOS, ESSENCIALMENTE DELIRANTES',
    codigo: 'F233',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS PSICÓTICOS AGUDOS E TRANSITÓRIOS',
    codigo: 'F238',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO PSICÓTICO AGUDO E TRANSITÓRIO NÃO ESPECIFICADO',
    codigo: 'F239',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DELIRANTE INDUZIDO',
    codigo: 'F24',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS ESQUIZOAFETIVOS',
    codigo: 'F25',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESQUIZOAFETIVO DO TIPO MANÍACO',
    codigo: 'F250',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESQUIZOAFETIVO DO TIPO DEPRESSIVO',
    codigo: 'F251',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESQUIZOAFETIVO DO TIPO MISTO',
    codigo: 'F252',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESQUIZOAFETIVOS',
    codigo: 'F258',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESQUIZOAFETIVO NÃO ESPECIFICADO',
    codigo: 'F259',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS PSICÓTICOS NÃO-ORGÂNICOS',
    codigo: 'F28',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PSICOSE NÃO-ORGÂNICA NÃO ESPECIFICADA',
    codigo: 'F29',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIO MANÍACO',
    codigo: 'F30',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'HIPOMANIA', codigo: 'F300', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'MANIA SEM SINTOMAS PSICÓTICOS',
    codigo: 'F301',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MANIA COM SINTOMAS PSICÓTICOS',
    codigo: 'F302',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS EPISÓDIOS MANÍACOS',
    codigo: 'F308',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIO MANÍACO NÃO ESPECIFICADO',
    codigo: 'F309',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR',
    codigo: 'F31',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, EPISÓDIO ATUAL HIPOMANÍACO',
    codigo: 'F310',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, EPISÓDIO ATUAL MANÍACO SEM SINTOMAS PSICÓTICOS',
    codigo: 'F311',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, EPISÓDIO ATUAL MANÍACO COM SINTOMAS PSICÓTICOS',
    codigo: 'F312',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, EPISÓDIO ATUAL DEPRESSIVO LEVE OU MODERADO',
    codigo: 'F313',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, EPISÓDIO ATUAL DEPRESSIVO GRAVE SEM SINTOMAS PSICÓTICOS',
    codigo: 'F314',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, EPISÓDIO ATUAL DEPRESSIVO GRAVE COM SINTOMAS PSICÓTICOS',
    codigo: 'F315',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, EPISÓDIO ATUAL MISTO',
    codigo: 'F316',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR, ATUALMENTE EM REMISSÃO',
    codigo: 'F317',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS AFETIVOS BIPOLARES',
    codigo: 'F318',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO AFETIVO BIPOLAR NÃO ESPECIFICADO',
    codigo: 'F319',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIOS DEPRESSIVOS',
    codigo: 'F32',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIO DEPRESSIVO LEVE',
    codigo: 'F320',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIO DEPRESSIVO MODERADO',
    codigo: 'F321',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIO DEPRESSIVO GRAVE SEM SINTOMAS PSICÓTICOS',
    codigo: 'F322',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIO DEPRESSIVO GRAVE COM SINTOMAS PSICÓTICOS',
    codigo: 'F323',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS EPISÓDIOS DEPRESSIVOS',
    codigo: 'F328',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EPISÓDIO DEPRESSIVO NÃO ESPECIFICADO',
    codigo: 'F329',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DEPRESSIVO RECORRENTE',
    codigo: 'F33',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DEPRESSIVO RECORRENTE, EPISÓDIO ATUAL LEVE',
    codigo: 'F330',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DEPRESSIVO RECORRENTE, EPISÓDIO ATUAL MODERADO',
    codigo: 'F331',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DEPRESSIVO RECORRENTE, EPISÓDIO ATUAL GRAVE SEM SINTOMAS PSICÓTICOS',
    codigo: 'F332',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DEPRESSIVO RECORRENTE, EPISÓDIO ATUAL GRAVE COM SINTOMAS PSICÓTICOS',
    codigo: 'F333',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DEPRESSIVO RECORRENTE, ATUALMENTE EM REMISSÃO',
    codigo: 'F334',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DEPRESSIVOS RECORRENTES',
    codigo: 'F338',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DEPRESSIVO RECORRENTE SEM ESPECIFICAÇÃO',
    codigo: 'F339',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DE HUMOR [AFETIVOS] PERSISTENTES',
    codigo: 'F34',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'CICLOTIMIA', codigo: 'F340', id_grupo: 'SAUDE_MENTAL' },
  { nm: null, nome: 'DISTIMIA', codigo: 'F341', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO HUMOR [AFETIVOS] PERSISTENTES',
    codigo: 'F348',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO HUMOR [AFETIVO] PERSISTENTE NÃO ESPECIFICADO',
    codigo: 'F349',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO HUMOR [AFETIVOS]',
    codigo: 'F38',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO HUMOR [AFETIVOS] ISOLADOS',
    codigo: 'F380',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO HUMOR [AFETIVOS] RECORRENTES',
    codigo: 'F381',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECIFICADOS DO HUMOR [AFETIVOS]',
    codigo: 'F388',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO HUMOR [AFETIVO] NÃO ESPECIFICADO',
    codigo: 'F39',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS FÓBICO-ANSIOSOS',
    codigo: 'F40',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'AGORAFOBIA', codigo: 'F400', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'FOBIAS SOCIAIS',
    codigo: 'F401',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'FOBIAS ESPECÍFICAS (ISOLADAS)',
    codigo: 'F402',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS FÓBICO-ANSIOSOS',
    codigo: 'F408',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO FÓBICO-ANSIOSO NÃO ESPECIFICADO',
    codigo: 'F409',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ANSIOSOS',
    codigo: 'F41',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE PÂNICO [ANSIEDADE PAROXÍSTICA EPISÓDICA]',
    codigo: 'F410',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ANSIEDADE GENERALIZADA',
    codigo: 'F411',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MISTO ANSIOSO E DEPRESSIVO',
    codigo: 'F412',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ANSIOSOS MISTOS',
    codigo: 'F413',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ANSIOSOS ESPECIFICADOS',
    codigo: 'F418',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ANSIOSO NÃO ESPECIFICADO',
    codigo: 'F419',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO OBSESSIVO-COMPULSIVO',
    codigo: 'F42',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO OBSESSIVO-COMPULSIVO COM PREDOMINÂNCIA DE IDÉIAS OU DE RUMINAÇÕES OBSESSIVAS',
    codigo: 'F420',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO OBSESSIVO-COMPULSIVO COM PREDOMINÂNCIA DE COMPORTAMENTOS COMPULSIVOS [RITUAIS OBSESSIVOS]',
    codigo: 'F421',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO OBSESSIVO-COMPULSIVO, FORMA MISTA, COM IDÉIAS OBSESSIVAS E COMPORTAMENTOS COMPULSIVOS',
    codigo: 'F422',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS OBSESSIVO-COMPULSIVOS',
    codigo: 'F428',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO OBSESSIVO-COMPULSIVO NÃO ESPECIFICADO',
    codigo: 'F429',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'REAÇÕES AO "STRESS" GRAVE E TRANSTORNOS DE ADAPTAÇÃO',
    codigo: 'F43',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'REAÇÃO AGUDA AO STRESS',
    codigo: 'F430',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESTADO DE STRESS PÓS-TRAUMÁTICO',
    codigo: 'F431',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DE ADAPTAÇÃO',
    codigo: 'F432',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRAS REAÇÕES AO STRESS GRAVE',
    codigo: 'F438',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'REAÇÃO NÃO ESPECIFICADA A UM STRESS GRAVE',
    codigo: 'F439',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DISSOCIATIVOS [DE CONVERSÃO]',
    codigo: 'F44',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'AMNÉSIA DISSOCIATIVA',
    codigo: 'F440',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'FUGA DISSOCIATIVA',
    codigo: 'F441',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESTUPOR DISSOCIATIVO',
    codigo: 'F442',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESTADOS DE TRANSE E DE POSSESSÃO',
    codigo: 'F443',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DISSOCIATIVOS DO MOVIMENTO',
    codigo: 'F444',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'CONVULSÕES DISSOCIATIVAS',
    codigo: 'F445',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ANESTESIA E PERDA SENSORIAL DISSOCIATIVAS',
    codigo: 'F446',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DISSOCIATIVO MISTO [DE CONVERSÃO]',
    codigo: 'F447',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DISSOCIATIVOS [DE CONVERSÃO]',
    codigo: 'F448',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DISSOCIATIVO [DE CONVERSÃO] NÃO ESPECIFICADO',
    codigo: 'F449',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS SOMATOFORMES',
    codigo: 'F45',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE SOMATIZAÇÃO',
    codigo: 'F450',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO SOMATOFORME INDIFERENCIADO',
    codigo: 'F451',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO HIPOCONDRÍACO',
    codigo: 'F452',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NEUROVEGETATIVO SOMATOFORME',
    codigo: 'F453',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DOLOROSO SOMATOFORME PERSISTENTE',
    codigo: 'F454',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS SOMATOFORMES',
    codigo: 'F458',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO SOMATOFORME NÃO ESPECIFICADO',
    codigo: 'F459',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS NEURÓTICOS',
    codigo: 'F48',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'NEURASTENIA', codigo: 'F480', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'SÍNDROME DE DESPERSONALIZAÇÃO-DESREALIZAÇÃO',
    codigo: 'F481',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS NEURÓTICOS ESPECIFICADOS',
    codigo: 'F488',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NEURÓTICO NÃO ESPECIFICADO',
    codigo: 'F489',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA ALIMENTAÇÃO',
    codigo: 'F50',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ANOREXIA NERVOSA',
    codigo: 'F500',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ANOREXIA NERVOSA ATÍPICA',
    codigo: 'F501',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'BULIMIA NERVOSA',
    codigo: 'F502',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'BULIMIA NERVOSA ATÍPICA',
    codigo: 'F503',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'HIPERFAGIA ASSOCIADA A OUTROS DISTÚRBIOS PSICOLÓGICOS',
    codigo: 'F504',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'VÔMITOS ASSOCIADOS A OUTROS DISTÚRBIOS PSICOLÓGICOS',
    codigo: 'F505',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA ALIMENTAÇÃO',
    codigo: 'F508',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE ALIMENTAÇÃO NÃO ESPECIFICADO',
    codigo: 'F509',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS NÃO-ORGÂNICOS DO SONO DEVIDOS A FATORES EMOCIONAIS',
    codigo: 'F51',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'INSÔNIA NÃO-ORGÂNICA',
    codigo: 'F510',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'HIPERSONIA NÃO-ORGÂNICA',
    codigo: 'F511',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO CICLO VIGÍLIA-SONO DEVIDO A FATORES NÃO-ORGÂNICOS',
    codigo: 'F512',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'SONAMBULISMO', codigo: 'F513', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'TERRORES NOTURNOS',
    codigo: 'F514',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'PESADELOS', codigo: 'F515', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO SONO DEVIDOS A FATORES NÃO-ORGÂNICOS',
    codigo: 'F518',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO SONO DEVIDO A FATORES NÃO-ORGÂNICOS NÃO ESPECIFICADOS',
    codigo: 'F519',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISFUNÇÃO SEXUAL, NÃO CAUSADA POR TRANSTORNO OU DOENÇA ORGÂNICA',
    codigo: 'F52',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'AUSÊNCIA OU PERDA DO DESEJO SEXUAL',
    codigo: 'F520',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'AVERSÃO SEXUAL E AUSÊNCIA DE PRAZER SEXUAL',
    codigo: 'F521',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'FALHA DE RESPOSTA GENITAL',
    codigo: 'F522',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISFUNÇÃO ORGÁSMICA',
    codigo: 'F523',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'EJACULAÇÃO PRECOCE',
    codigo: 'F524',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'VAGINISMO NÃO-ORGÂNICO',
    codigo: 'F525',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISPAREUNIA NÃO-ORGÂNICA',
    codigo: 'F526',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'APETITE SEXUAL EXCESSIVO',
    codigo: 'F527',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRAS DISFUNÇÕES SEXUAIS NÃO DEVIDAS A TRANSTORNO OU À DOENÇA ORGÂNICA',
    codigo: 'F528',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISFUNÇÃO SEXUAL NÃO DEVIDA A TRANSTORNO OU À DOENÇA ORGÂNICA, NÃO ESPECIFICADA',
    codigo: 'F529',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS ASSOCIADOS AO PUERPÉRIO NÃO CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F53',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS LEVES ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F530',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS GRAVES ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F531',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS MENTAIS E COMPORTAMENTAIS ASSOCIADOS AO PUERPÉRIO Ñ CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F538',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MENTAL E COMPORTAMENTAL ASSOCIADO AO PUERPÉRIO, NÃO ESPECIFICADO',
    codigo: 'F539',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'FATORES PSICOLÓGICOS OU COMPORTAMENTAIS ASSOCIADOS A DOENÇA OU TRANST. CLASSIFICADOS EM OUTRA PARTE',
    codigo: 'F54',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ABUSO DE SUBSTÂNCIAS QUE NÃO PRODUZEM DEPENDÊNCIA',
    codigo: 'F55',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SÍNDROMES COMPORTAMENTAIS ASSOCIADOS A TRANST. DAS FUNÇÕES FISIOL. E A FAT. FÍSICOS, Ñ ESPECIFICADAS',
    codigo: 'F59',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS ESPECÍFICOS DA PERSONALIDADE',
    codigo: 'F60',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERSONALIDADE PARANÓICA',
    codigo: 'F600',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERSONALIDADE ESQUIZÓIDE',
    codigo: 'F601',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERSONALIDADE DISSOCIAL',
    codigo: 'F602',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE PERSONALIDADE COM INSTABILIDADE EMOCIONAL',
    codigo: 'F603',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERSONALIDADE HISTRIÔNICA',
    codigo: 'F604',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERSONALIDADE ANANCÁSTICA',
    codigo: 'F605',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERSONALIDADE ANSIOSA [ESQUIVA]',
    codigo: 'F606',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERSONALIDADE DEPENDENTE',
    codigo: 'F607',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECÍFICOS DA PERSONALIDADE',
    codigo: 'F608',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NÃO ESPECIFICADO DA PERSONALIDADE',
    codigo: 'F609',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MISTOS DA PERSONALIDADE E OUTROS TRANSTORNOS DA PERSONALIDADE',
    codigo: 'F61',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MODIFICAÇÕES DURADOURAS DA PERSONALIDADE NÃO ATRIBUÍVEIS A LESÃO OU DOENÇA CEREBRAL',
    codigo: 'F62',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MODIFICAÇÃO DURADOURA DA PERSONALIDADE APÓS UMA EXPERIÊNCIA CATASTRÓFICA',
    codigo: 'F620',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MODIFICAÇÃO DURADOURA DA PERSONALIDADE APÓS DOENÇA PSIQUIÁTRICA',
    codigo: 'F621',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRAS MODIFICAÇÕES DURADOURAS DA PERSONALIDADE',
    codigo: 'F628',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MODIFICAÇÃO DURADOURA DA PERSONALIDADE, NÃO ESPECIFICADA',
    codigo: 'F629',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DOS HÁBITOS E DOS IMPULSOS',
    codigo: 'F63',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'JOGO PATOLÓGICO',
    codigo: 'F630',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'PIROMANIA', codigo: 'F631', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'ROUBO PATOLÓGICO [CLEPTOMANIA]',
    codigo: 'F632',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRICOTILOMANIA',
    codigo: 'F633',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DOS HÁBITOS E DOS IMPULSOS',
    codigo: 'F638',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DOS HÁBITOS E IMPULSOS, NÃO ESPECIFICADO',
    codigo: 'F639',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA IDENTIDADE SEXUAL',
    codigo: 'F64',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSEXUALISMO',
    codigo: 'F640',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRAVESTISMO BIVALENTE',
    codigo: 'F641',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE IDENTIDADE SEXUAL NA INFÂNCIA',
    codigo: 'F642',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA IDENTIDADE SEXUAL',
    codigo: 'F648',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NÃO ESPECIFICADO DA IDENTIDADE SEXUAL',
    codigo: 'F649',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA PREFERÊNCIA SEXUAL',
    codigo: 'F65',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'FETICHISMO', codigo: 'F650', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'TRAVESTISMO FETICHISTA',
    codigo: 'F651',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'EXIBICIONISMO', codigo: 'F652', id_grupo: 'SAUDE_MENTAL' },
  { nm: null, nome: 'VOYEURISMO', codigo: 'F653', id_grupo: 'SAUDE_MENTAL' },
  { nm: null, nome: 'PEDOFILIA', codigo: 'F654', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'SADOMASOQUISMO',
    codigo: 'F655',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MÚLTIPLOS DA PREFERÊNCIA SEXUAL',
    codigo: 'F656',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA PREFERÊNCIA SEXUAL',
    codigo: 'F658',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DA PREFERÊNCIA SEXUAL, NÃO ESPECIFICADO',
    codigo: 'F659',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS PSICOLÓGICOS E COMPORTAMENTAIS ASSOCIADOS AO DESENVOLVIMENTO SEXUAL E À SUA ORIENTAÇÃO',
    codigo: 'F66',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DA MATURAÇÃO SEXUAL',
    codigo: 'F660',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ORIENTAÇÃO SEXUAL EGODISTÔNICA',
    codigo: 'F661',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO RELACIONAMENTO SEXUAL',
    codigo: 'F662',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO DESENVOLVIMENTO PSICOSSEXUAL',
    codigo: 'F668',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO DESENVOLVIMENTO SEXUAL, NÃO ESPECIFICADO',
    codigo: 'F669',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DA PERSONALIDADE E DO COMPORTAMENTO DO ADULTO',
    codigo: 'F68',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SINTOMAS FÍSICOS AUMENTADOS POR FATORES PSICOLÓGICOS',
    codigo: 'F680',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PRODUÇÃO DELIBERADA OU SIMULAÇÃO DE SINTOMAS OU DE INCAPACIDADES, FÍSICAS OU PSICOLÓGICAS',
    codigo: 'F681',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECIFICADOS DA PERSONALIDADE E DO COMPORTAMENTO DO ADULTO',
    codigo: 'F688',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DA PERSONALIDADE E DO COMPORTAMENTO DO ADULTO, NÃO ESPECIFICADO',
    codigo: 'F69',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL LEVE',
    codigo: 'F70',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL LEVE - MENÇÃO DE AUSÊNCIA DE OU DE COMPROMETIMENTO MÍNIMO DO COMPORTAMENTO',
    codigo: 'F700',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL LEVE - COMPROMETIMENTO SIGNIF. DO COMPORTAMENTO, REQUERENDO VIGILÂNCIA OU TRATAMENTO',
    codigo: 'F701',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL LEVE - OUTROS COMPROMETIMENTOS DO COMPORTAMENTO',
    codigo: 'F708',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL LEVE - SEM MENÇÃO DE COMPROMETIMENTO DO COMPORTAMENTO',
    codigo: 'F709',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL MODERADO',
    codigo: 'F71',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL MODERADO - MENÇÃO DE AUSÊNCIA DE OU DE COMPROMETIMENTO MÍNIMO DO COMPORTAMENTO',
    codigo: 'F710',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL MODERADO - COMPROMETIMENTO SIGNIF. DO COMPORT., REQUERENDO VIGILÂNCIA OU TRATAMENTO',
    codigo: 'F711',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL MODERADO - OUTROS COMPROMETIMENTOS DO COMPORTAMENTO',
    codigo: 'F718',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL MODERADO - SEM MENÇÃO DE COMPROMETIMENTO DO COMPORTAMENTO',
    codigo: 'F719',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL GRAVE',
    codigo: 'F72',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL GRAVE - MENÇÃO DE AUSÊNCIA DE OU DE COMPROMETIMENTO MÍNIMO DO COMPORTAMENTO',
    codigo: 'F720',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL GRAVE - COMPROMETIMENTO SIGNIF. DO COMPORTAMENTO, REQUERENDO VIGILÂNCIA OU TRATAMENTO',
    codigo: 'F721',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL GRAVE - OUTROS COMPROMETIMENTOS DO COMPORTAMENTO',
    codigo: 'F728',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL GRAVE - SEM MENÇÃO DE COMPROMETIMENTO DO COMPORTAMENTO',
    codigo: 'F729',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL PROFUNDO',
    codigo: 'F73',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL PROFUNDO - MENÇÃO DE AUSÊNCIA DE OU DE COMPROMETIMENTO MÍNIMO DO COMPORTAMENTO',
    codigo: 'F730',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL PROFUNDO - COMPROMETIMENTO SIGNIF. DO COMPORT., REQUERENDO VIGILÂNCIA OU TRATAMENTO',
    codigo: 'F731',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL PROFUNDO - OUTROS COMPROMETIMENTOS DO COMPORTAMENTO',
    codigo: 'F738',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL PROFUNDO - SEM MENÇÃO DE COMPROMETIMENTO DO COMPORTAMENTO',
    codigo: 'F739',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRO RETARDO MENTAL',
    codigo: 'F78',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRO RETARDO MENTAL - MENÇÃO DE AUSÊNCIA DE OU DE COMPROMETIMENTO MÍNIMO DO COMPORTAMENTO',
    codigo: 'F780',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRO RETARDO MENTAL - COMPROMETIMENTO SIGNIF. DO COMPORTAMENTO, REQUERENDO VIGILÂNCIA OU TRATAMENTO',
    codigo: 'F781',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRO RETARDO MENTAL - OUTROS COMPROMETIMENTOS DO COMPORTAMENTO',
    codigo: 'F788',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRO RETARDO MENTAL - SEM MENÇÃO DE COMPROMETIMENTO DO COMPORTAMENTO',
    codigo: 'F789',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL NÃO ESPECIFICADO',
    codigo: 'F79',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL NÃO ESPECIFICADO - MENÇÃO DE AUSÊNCIA OU DE COMPROMETIMENTO MÍNIMO DO COMPORTAMENTO',
    codigo: 'F790',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL NÃO ESPECIFICADO - COMPROMET. SIGNIF. COMPORTAM., REQUERENDO VIGILÂNCIA OU TRATAMENTO',
    codigo: 'F791',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL NÃO ESPECIFICADO - OUTROS COMPROMETIMENTOS DO COMPORTAMENTO',
    codigo: 'F798',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO MENTAL NÃO ESPECIFICADO - SEM MENÇÃO DE COMPROMETIMENTO DO COMPORTAMENTO',
    codigo: 'F799',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS ESPECÍFICOS DO DESENVOLVIMENTO DA FALA E DA LINGUAGEM',
    codigo: 'F80',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESPECÍFICO DA ARTICULAÇÃO DA FALA',
    codigo: 'F800',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO EXPRESSIVO DE LINGUAGEM',
    codigo: 'F801',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO RECEPTIVO DA LINGUAGEM',
    codigo: 'F802',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'AFASIA ADQUIRIDA COM EPILEPSIA [SÍNDROME DE LANDAU-KLEFFNER]',
    codigo: 'F803',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DE DESENVOLVIMENTO DA FALA OU DA LINGUAGEM',
    codigo: 'F808',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NÃO ESPECIFICADO DO DESENVOLVIMENTO DA FALA OU DA LINGUAGEM',
    codigo: 'F809',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS ESPECÍFICOS DO DESENVOLVIMENTO DAS HABILIDADES ESCOLARES',
    codigo: 'F81',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESPECÍFICO DE LEITURA',
    codigo: 'F810',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESPECÍFICO DA SOLETRAÇÃO',
    codigo: 'F811',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESPECÍFICO DA HABILIDADE EM ARITMÉTICA',
    codigo: 'F812',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MISTO DE HABILIDADES ESCOLARES',
    codigo: 'F813',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO DESENVOLVIMENTO DAS HABILIDADES ESCOLARES',
    codigo: 'F818',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NÃO ESPECIFICADO DO DESENVOLVIMENTO DAS HABILIDADES ESCOLARES',
    codigo: 'F819',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO ESPECÍFICO DO DESENVOLVIMENTO MOTOR',
    codigo: 'F82',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS ESPECÍFICOS MISTO DO DESENVOLVIMENTO',
    codigo: 'F83',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS GLOBAIS DO DESENVOLVIMENTO',
    codigo: 'F84',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'AUTISMO INFANTIL',
    codigo: 'F840',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'AUTISMO ATÍPICO',
    codigo: 'F841',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SÍNDROME DE RETT',
    codigo: 'F842',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRO TRANSTORNO DESINTEGRATIVO DA INFÂNCIA',
    codigo: 'F843',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO COM HIPERCINESIA ASSOCIADA A RETARDO MENTAL E A MOVIMENTOS ESTEREOTIPADOS',
    codigo: 'F844',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SÍNDROME DE ASPERGER',
    codigo: 'F845',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS GLOBAIS DO DESENVOLVIMENTO',
    codigo: 'F848',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS GLOBAIS NÃO ESPECIFICADOS DO DESENVOLVIMENTO',
    codigo: 'F849',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO DESENVOLVIMENTO PSICOLÓGICO',
    codigo: 'F88',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO DESENVOLVIMENTO PSICOLÓGICO NÃO ESPECIFICADO',
    codigo: 'F89',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS HIPERCINÉTICOS',
    codigo: 'F90',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIOS DA ATIVIDADE E DA ATENÇÃO',
    codigo: 'F900',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO HIPERCINÉTICO DE CONDUTA',
    codigo: 'F901',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS HIPERCINÉTICOS',
    codigo: 'F908',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO HIPERCINÉTICO NÃO ESPECIFICADO',
    codigo: 'F909',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIOS DE CONDUTA',
    codigo: 'F91',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO DE CONDUTA RESTRITO AO CONTEXTO FAMILIAR',
    codigo: 'F910',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO DE CONDUTA NÃO-SOCIALIZADO',
    codigo: 'F911',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO DE CONDUTA DO TIPO SOCIALIZADO',
    codigo: 'F912',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO DESAFIADOR E DE OPOSIÇÃO',
    codigo: 'F913',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DE CONDUTA',
    codigo: 'F918',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE CONDUTA NÃO ESPECIFICADO',
    codigo: 'F919',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MISTOS DE CONDUTA E DAS EMOÇÕES',
    codigo: 'F92',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO DEPRESSIVO DE CONDUTA',
    codigo: 'F920',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS MISTOS DA CONDUTA E DAS EMOÇÕES',
    codigo: 'F928',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MISTO DA CONDUTA E DAS EMOÇÕES NÃO ESPECIFICADO',
    codigo: 'F929',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS EMOCIONAIS COM INÍCIO ESPECIFICAMENTE NA INFÂNCIA',
    codigo: 'F93',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO LIGADO À ANGÚSTIA DE SEPARAÇÃO',
    codigo: 'F930',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO FÓBICO ANSIOSO DA INFÂNCIA',
    codigo: 'F931',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO DE ANSIEDADE SOCIAL DA INFÂNCIA',
    codigo: 'F932',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE RIVALIDADE ENTRE IRMÃOS',
    codigo: 'F933',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS EMOCIONAIS DA INFÂNCIA',
    codigo: 'F938',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO EMOCIONAL DA INFÂNCIA NÃO ESPECIFICADO',
    codigo: 'F939',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DO FUNCIONAMENTO SOCIAL COM INÍCIO ESPECIFICAMENTE DURANTE A INFÂNCIA OU A ADOLESCÊNCIA',
    codigo: 'F94',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MUTISMO ELETIVO',
    codigo: 'F940',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO REATIVO DE VINCULAÇÃO DA INFÂNCIA',
    codigo: 'F941',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE FIXAÇÃO DA INFÂNCIA, COM DESINIBIÇÃO',
    codigo: 'F942',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS DO FUNCIONAMENTO SOCIAL NA INFÂNCIA',
    codigo: 'F948',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DO FUNCIONAMENTO SOCIAL DA INFÂNCIA NÃO ESPECIFICADO',
    codigo: 'F949',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'TIQUES', codigo: 'F95', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'TIQUE TRANSITÓRIO',
    codigo: 'F950',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TIQUE MOTOR OU VOCAL CRÔNICO',
    codigo: 'F951',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TIQUES VOCAIS E MOTORES MÚLTIPLOS COMBINADOS [DOENÇA DE GILLES DE LA TOURETTE]',
    codigo: 'F952',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'OUTROS TIQUES', codigo: 'F958', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'TIQUE NÃO ESPECIFICADO',
    codigo: 'F959',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS COMPORTAMENTAIS E EMOCIONAIS COM INÍCIO HABITUALMENTE DURANTE A INFÂNCIA OU A ADOLESCÊNCIA',
    codigo: 'F98',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ENURESE DE ORIGEM NÃO-ORGÂNICA',
    codigo: 'F980',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ENCOPRESE DE ORIGEM NÃO-ORGÂNICA',
    codigo: 'F981',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO DE ALIMENTAÇÃO NA INFÂNCIA',
    codigo: 'F982',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PICA DO LACTENTE OU DA CRIANÇA',
    codigo: 'F983',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ESTEREOTIPIAS MOTORAS',
    codigo: 'F984',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'GAGUEIRA [TARTAMUDEZ]',
    codigo: 'F985',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'LINGUAGEM PRECIPITADA',
    codigo: 'F986',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS COMPORTAM. E EMOCIONAIS ESPECIF. C/ INÍCIO HABITUAL. NA INFÂNCIA OU ADOLESCÊNCIA',
    codigo: 'F988',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS COMPORTAM. E EMOCIONAIS Ñ ESPECIF. COM INÍCIO HABITUALMENTE NA INFÂNCIA OU ADOLESCÊNCIA',
    codigo: 'F989',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'TRANSTORNO MENTAL NÃO ESPECIFICADO EM OUTRA PARTE',
    codigo: 'F99',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE',
    codigo: 'N80',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO ÚTERO',
    codigo: 'N800',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO OVÁRIO',
    codigo: 'N801',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DA TROMPA DE FALÓPIO',
    codigo: 'N802',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO PERITÔNIO PÉLVICO',
    codigo: 'N803',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO SEPTO RETOVAGINAL E DA VAGINA',
    codigo: 'N804',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE DO INTESTINO',
    codigo: 'N805',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE EM CICATRIZ CUTÂNEA',
    codigo: 'N806',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRA ENDOMETRIOSE',
    codigo: 'N808',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ENDOMETRIOSE NÃO ESPECIFICADA',
    codigo: 'N809',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO AUSENTE ESCASSA E POUCO FREQUENTE',
    codigo: 'N91',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AMENORRÉIA PRIMÁRIA',
    codigo: 'N910',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AMENORRÉIA SECUNDÁRIA',
    codigo: 'N911',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AMENORRÉIA, NÃO ESPECIFICADA',
    codigo: 'N912',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OLIGOMENORRÉIA PRIMÁRIA',
    codigo: 'N913',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OLIGOMENORRÉIA SECUNDÁRIA',
    codigo: 'N914',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OLIGOMENORRÉIA, NÃO ESPECIFICADA',
    codigo: 'N915',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA FREQUENTE E IRREGULAR',
    codigo: 'N92',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA E FREQÜENTE COM CICLO REGULAR',
    codigo: 'N920',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA E FREQÜENTE COM CICLO IRREGULAR',
    codigo: 'N921',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA NA PUBERDADE',
    codigo: 'N922',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO DA OVULAÇÃO',
    codigo: 'N923',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO ABUNDANTE NA PRÉ-MENOPAUSA',
    codigo: 'N924',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS TIPOS ESPECIFICADOS DE IRREGULARIDADE DA MENSTRUAÇÃO',
    codigo: 'N925',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO IRREGULAR, NÃO ESPECIFICADA',
    codigo: 'N926',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS SANGRAMENTOS ANORMAIS DO ÚTERO E DA VAGINA',
    codigo: 'N93',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTOS PÓS-COITO OU DE CONTATO',
    codigo: 'N930',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS SANGRAMENTOS ANORMAIS ESPECIFICADOS DO ÚTERO E DA VAGINA',
    codigo: 'N938',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO ANORMAL DO ÚTERO OU DA VAGINA, NÃO ESPECIFICADO',
    codigo: 'N939',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES ASSOCIADAS COM OS ORGÃOS GENITAIS FEMININOS E COM O CICLO MENSTRUAL',
    codigo: 'N94',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OVULAÇÃO DOLOROSA [MITTELSCHMERZ]',
    codigo: 'N940',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISPAREUNIA',
    codigo: 'N941',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'VAGINISMO',
    codigo: 'N942',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SÍNDROME DE TENSÃO PRÉ-MENSTRUAL',
    codigo: 'N943',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISMENORRÉIA PRIMÁRIA',
    codigo: 'N944',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISMENORRÉIA SECUNDÁRIA',
    codigo: 'N945',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DISMENORRÉIA NÃO ESPECIFICADA',
    codigo: 'N946',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRAS AFECÇÕES ESPECIFICADAS ASSOCIADAS COM OS ÓRGÃOS GENITAIS FEMININOS E COM O CICLO MENSTRUAL',
    codigo: 'N948',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AFECÇÕES NÃO ESPECIFICADAS ASSOCIADAS COM OS ÓRGÃOS GENITAIS FEMININOS E COM O CICLO MENSTRUAL',
    codigo: 'N949',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS DA MENOPAUSA E DA PERIMENOPAUSA',
    codigo: 'N95',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SANGRAMENTO PÓS-MENOPAUSA',
    codigo: 'N950',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ESTADO DA MENOPAUSA E DO CLIMATÉRIO FEMININO',
    codigo: 'N951',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'VAGINITE ATRÓFICA PÓS-MENOPAUSA',
    codigo: 'N952',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONDIÇÕES ASSOCIADAS COM A MENOPAUSA ARTIFICIAL',
    codigo: 'N953',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS TRANSTORNOS ESPECIFICADOS DA MENOPAUSA E DA PERIMENOPAUSA',
    codigo: 'N958',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'TRANSTORNO NÃO ESPECIFICADO DA MENOPAUSA E DA PERIMENOPAUSA',
    codigo: 'N959',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTAMENTO HABITUAL',
    codigo: 'N96',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA',
    codigo: 'N97',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA ASSOCIADA À ANOVULAÇÃO',
    codigo: 'N970',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE ORIGEM TUBÁRIA',
    codigo: 'N971',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE ORIGEM UTERINA',
    codigo: 'N972',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE ORIGEM CERVICAL',
    codigo: 'N973',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA ASSOCIADA À FATORES DO PARCEIRO',
    codigo: 'N974',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA DE OUTRA ORIGEM',
    codigo: 'N978',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE FEMININA NÃO ESPECIFICADA',
    codigo: 'N979',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTO ESPONTÂNEO',
    codigo: 'O03',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTO POR RAZÕES MEDICAS E LEGAIS',
    codigo: 'O04',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DOR PÉLVICA E PERINEAL',
    codigo: 'R102',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABUSO SEXUAL',
    codigo: 'T742',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - RESIDÊNCIA',
    codigo: 'Y050',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - HABITAÇÃO COLETIVA',
    codigo: 'Y051',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ESCOLAS, OUTRAS INSTIT. E ÁREAS DE ADMINIST. PÚBLICA',
    codigo: 'Y052',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ÁREA PARA A PRÁTICA DE ESPORTES E ATLETISMO',
    codigo: 'Y053',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - RUA E ESTRADA',
    codigo: 'Y054',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ÁREAS DE COMÉRCIO E DE SERVIÇOS',
    codigo: 'Y055',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - ÁREAS INDUSTRIAIS E EM CONSTRUÇÃO',
    codigo: 'Y056',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - FAZENDA',
    codigo: 'Y057',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - OUTROS LOCAIS ESPECIFICADOS',
    codigo: 'Y058',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'AGRESSÃO SEXUAL POR MEIO DE FORÇA FÍSICA - LOCAL NÃO ESPECIFICADO',
    codigo: 'Y059',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'EXAME ESPECIAL DE RASTREAMENTO DE NEOPLASIA DE MAMA',
    codigo: 'Z123',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'EXAME ESPECIAL DE RASTREAMENTO DE NEOPLASIA DO COLO DO ÚTERO',
    codigo: 'Z124',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTATO COM E EXPOSIÇÃO À HEPATITE VIRAL',
    codigo: 'Z205',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTATO COM E EXPOSIÇÃO AO VÍRUS DA IMUNODEFICIÊNCIA HUMANA [HIV]',
    codigo: 'Z206',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ANTICONCEPÇÃO',
    codigo: 'Z30',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO GERAL SOBRE CONTRACEPÇÃO',
    codigo: 'Z300',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INSERÇÃO DE DISPOSITIVO ANTICONCEPCIONAL (INTRA-UTERINO)',
    codigo: 'Z301',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ESTERILIZAÇÃO',
    codigo: 'Z302',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'EXTRAÇÃO MENSTRUAL',
    codigo: 'Z303',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DO USO DE MEDICAMENTOS ANTICONCEPCIONAIS',
    codigo: 'Z304',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SUPERVISÃO DE DISPOSITIVO ANTICONCEPCIONAL (INTRA-UTERINO)',
    codigo: 'Z305',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRO PROCEDIMENTO ANTICONCEPCIONAL',
    codigo: 'Z308',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROCEDIMENTO ANTICONCEPCIONAL NÃO ESPECIFICADO',
    codigo: 'Z309',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDIDAS DE PROCRIAÇÃO',
    codigo: 'Z31',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'TUBOPLASTIA OU VASOPLASTIA APÓS ESTERILIZAÇÃO PRÉVIA',
    codigo: 'Z310',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INSEMINAÇÃO ARTIFICIAL',
    codigo: 'Z311',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'FECUNDAÇÃO IN VITRO',
    codigo: 'Z312',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS MÉTODOS ASSISTIDOS DE FERTILIZAÇÃO',
    codigo: 'Z313',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INVESTIGAÇÃO E TESTES COM RELAÇÃO À PROCRIAÇÃO',
    codigo: 'Z314',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO GENÉTICO',
    codigo: 'Z315',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO GERAL SOBRE A PROCRIAÇÃO',
    codigo: 'Z316',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTRA MEDIDA ESPECIFICADA DE PROCRIAÇÃO',
    codigo: 'Z318',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDIDA PROCRIATIVA NÃO ESPECIFICADA',
    codigo: 'Z319',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ (AINDA) NÃO CONFIRMADA',
    codigo: 'Z320',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROBLEMAS DE ADAPTAÇÃO ÀS TRANSIÇÕES DO CICLO DE VIDA',
    codigo: 'Z600',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROBLEMAS NAS RELAÇÕES COM CÔNJUGE OU PARCEIRO',
    codigo: 'Z630',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PROBLEMAS RELACIONADOS COM UMA GRAVIDEZ NÃO DESEJADA',
    codigo: 'Z640',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO ÀS ATITUDES, COMPORTAMENTO E ORIENTAÇÃO EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z70',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACOMPANHAMENTO RELATIVO ÀS ATITUDES EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z700',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO AO COMPORTAMENTO E À ORIENTAÇÃO SEXUAL DO SUJEITO',
    codigo: 'Z701',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO AO COMPORTAMENTO E À ORIENTAÇÃO SEXUAL DE UM TERCEIRO',
    codigo: 'Z702',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO RELATIVO A PREOC. RELAC. COM ATITUDES, COMPORT. E ORIENT. EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z703',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'OUTROS ACONSELHAMENTOS EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z708',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO NÃO ESPECIFICADO EM MATÉRIA DE SEXUALIDADE',
    codigo: 'Z709',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO A PROPÓSITO DO VÍRUS DA IMUNODEFICIÊNCIA HUMANA [HIV]',
    codigo: 'Z717',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'COMPORTAMENTO SEXUAL DE ALTO RISCO',
    codigo: 'Z725',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE FUMO',
    codigo: 'F17',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - INTOXICAÇÃO AGUDA',
    codigo: 'F170',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - USO NOCIVO PARA A SAÚDE',
    codigo: 'F171',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F172',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - SÍNDROME [ESTADO] DE ABSTINÊNCIA',
    codigo: 'F173',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - SÍNDROME DE ABSTINÊNCIA COM DELÍRIO',
    codigo: 'F174',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - TRANSTORNO PSICÓTICO',
    codigo: 'F175',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - SÍNDROME AMNÉSICA',
    codigo: 'F176',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - TRANSTORNO PSICÓTICO RESIDUAL OU DE INSTALAÇÃO TARDIA',
    codigo: 'F177',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - OUTROS TRANSTORNOS MENTAIS OU COMPORTAMENTAIS',
    codigo: 'F178',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO FUMO - TRANSTORNO MENTAL OU COMPORTAMENTAL NÃO ESPECIFICADO',
    codigo: 'F179',
    id_grupo: 'TABAGISMO',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO PARA O ABUSO DE FUMO',
    codigo: 'Z716',
    id_grupo: 'TABAGISMO',
  },
  { nm: null, nome: 'USO DO TABACO', codigo: 'Z720', id_grupo: 'TABAGISMO' },
  {
    nm: null,
    nome: 'TUBERCULOSE RESPIRATÓRIA COM CONFIRMAÇÃO BACTERIOLÓGICA E HISTOLÓGICA',
    codigo: 'A15',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PULMONAR, COM CONFIRMAÇÃO POR EXAME MICROSCÓPICO DA EXPECTORAÇÃO, COM OU SEM CULTURA',
    codigo: 'A150',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PULMONAR, COM CONFIRMAÇÃO SOMENTE POR CULTURA',
    codigo: 'A151',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PULMONAR, COM CONFIRMAÇÃO HISTOLÓGICA',
    codigo: 'A152',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PULMONAR, COM CONFIRMAÇÃO POR MEIO NÃO ESPECIFICADO',
    codigo: 'A153',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DOS GÂNGLIOS INTRATORÁCICOS, COM CONFIRMAÇÃO BACTERIOLÓGICA E HISTOLÓGICA',
    codigo: 'A154',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DA LARINGE, DA TRAQUÉIA E DOS BRÔNQUIOS, COM CONFIRMAÇÃO BACTERIOLÓGICA E HISTOLÓGICA',
    codigo: 'A155',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'PLEURIS TUBERCULOSO, COM CONFIRMAÇÃO BACTERIOLÓGICA E HISTOLÓGICA',
    codigo: 'A156',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PRIMÁRIA DAS VIAS RESPIRATÓRIAS, COM CONFIRMAÇÃO BACTERIOLÓGICA E HISTOLÓGICA',
    codigo: 'A157',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE TUBERCULOSE DAS VIAS RESPIRATÓRIAS, COM CONFIRMAÇÃO BACTERIOLÓGICA E HISTOLÓGICA',
    codigo: 'A158',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE NÃO ESPECIFICADA DAS VIAS RESPIRATÓRIAS, COM CONFIRMAÇÃO BACTERIOLÓGICA E HISTOLÓGICA',
    codigo: 'A159',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DAS VIAS RESPIRATÓRIAS, SEM CONFIRMAÇÃO BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A16',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PULMONAR COM EXAMES BACTERIOLÓGICO E HISTOLÓGICO NEGATIVOS',
    codigo: 'A160',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PULMONAR, SEM REALIZAÇÃO DE EXAME BACTERIOLÓGICO OU HISTOLÓGICO',
    codigo: 'A161',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE PULMONAR, SEM MENÇÃO DE CONFIRMAÇÃO BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A162',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DOS GÂNGLIOS INTRATORÁCICOS, SEM MENÇÃO DE CONFIRMAÇÃO BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A163',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DA LARINGE, TRAQUÉIA E BRÔNQUIOS, SEM MENÇÃO DE CONFIRM. BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A164',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'PLEURISIA TUBERCULOSA, SEM MENÇÃO DE CONFIRMAÇÃO BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A165',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSA RESPIRATÓRIA PRIMÁRIA SEM MENÇÃO DE CONFIRMAÇÃO BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A167',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'OUTRAS FORMAS DE TUBERCUL. DAS VIAS RESPIRAT., SEM MENÇÃO DE CONFIRM. BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A168',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE RESPIRATÓRIA, NÃO ESPECIFICADA, SEM MENÇÃO DE CONFIRMAÇÃO BACTERIOLÓGICA OU HISTOLÓGICA',
    codigo: 'A169',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DO SISTEMA NERVOSO',
    codigo: 'A17',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'MENINGITE TUBERCULOSA',
    codigo: 'A170',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOMA MENÍNGEO',
    codigo: 'A171',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'OUTRAS TUBERCULOSES DO SISTEMA NERVOSO',
    codigo: 'A178',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE NÃO ESPECIFICADA DO SISTEMA NERVOSO',
    codigo: 'A179',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DE OUTROS ÓRGÃOS',
    codigo: 'A18',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE ÓSSEA E DAS ARTICULAÇÕES',
    codigo: 'A180',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DO APARELHO GENITURINÁRIO',
    codigo: 'A181',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'LINFADENOPATIA TUBERCULOSA PERIFÉRICA',
    codigo: 'A182',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DO INTESTINO, DO PERITÔNIO E DOS GÂNGLIOS MESENTÉRICOS',
    codigo: 'A183',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DE PELE E DO TECIDO CELULAR SUBCUTÂNEO',
    codigo: 'A184',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DO OLHO',
    codigo: 'A185',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DO OUVIDO',
    codigo: 'A186',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DAS SUPRA-RENAIS',
    codigo: 'A187',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE DE OUTROS ÓRGÃOS ESPECIFICADOS',
    codigo: 'A188',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE MILIAR',
    codigo: 'A19',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE MILIAR AGUDA DE LOCALIZAÇÃO ÚNICA E ESPECIFICADA',
    codigo: 'A190',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE MILIAR AGUDA DE MÚLTIPLAS LOCALIZAÇÕES',
    codigo: 'A191',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE MILIAR AGUDA NÃO ESPECIFICADA',
    codigo: 'A192',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'OUTRAS TUBERCULOSES MILIARES',
    codigo: 'A198',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TUBERCULOSE MILIAR NÃO ESPECIFICADA',
    codigo: 'A199',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE TUBERCULOSE',
    codigo: 'B90',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE TUBERCULOSE DO SISTEMA NERVOSO CENTRAL',
    codigo: 'B900',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE TUBERCULOSE GENITURINÁRIA',
    codigo: 'B901',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE TUBERCULOSE ÓSSEA E DAS ARTICULAÇÕES',
    codigo: 'B902',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE TUBERCULOSE DE OUTROS ÓRGÃOS',
    codigo: 'B908',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'SEQÜELAS DE TUBERCULOSE DAS VIAS RESPIRATÓRIAS E DE ÓRGÃOS NÃO ESPECIFICADOS',
    codigo: 'B909',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'PNEUMOCONIOSE ASSOCIADA COM TUBERCULOSE',
    codigo: 'J65',
    id_grupo: 'TUBERCULOSE',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE ÁLCOOL',
    codigo: 'F10',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - INTOXICAÇÃO AGUDA',
    codigo: 'F100',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - USO NOCIVO PARA A SAÚDE',
    codigo: 'F101',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F102',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - SÍNDROME [ESTADO] DE ABSTINÊNCIA',
    codigo: 'F103',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - SÍNDROME DE ABSTINÊNCIA COM DELÍRIO',
    codigo: 'F104',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - TRANSTORNO PSICÓTICO',
    codigo: 'F105',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - SÍNDROME AMNÉSICA',
    codigo: 'F106',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - TRANST. PSICÓT. RESIDUAL OU DE INSTAL. TARDIA',
    codigo: 'F107',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - OUTROS TRANSTORNOS MENTAIS OU COMPORTAMENTAIS',
    codigo: 'F108',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEVIDOS USO DE ÁLCOOL - TRANSTORNO MENTAL OU COMPORT. Ñ ESPECIFICADO',
    codigo: 'F109',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'REABILITAÇÃO DE ALCOÓLATRA',
    codigo: 'Z502',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO E SUPERVISÃO PARA ABUSO DE ÁLCOOL',
    codigo: 'Z714',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'USO DE ÁLCOOL',
    codigo: 'Z721',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE OPIÁCEOS',
    codigo: 'F11',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - INTOXICAÇÃO AGUDA',
    codigo: 'F110',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - USO NOCIVO PARA A SAÚDE',
    codigo: 'F111',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F112',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - SÍNDROME [ESTADO] DE ABSTINÊNCIA',
    codigo: 'F113',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - SÍNDROME DE ABSTIN. COM DELÍRIO',
    codigo: 'F114',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - TRANSTORNO PSICÓTICO',
    codigo: 'F115',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - SÍNDROME AMNÉSICA',
    codigo: 'F116',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - TRANST. PSICÓT. RESIDUAL OU DE INSTAL. TARDIA',
    codigo: 'F117',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - OUTROS TRANSTORNOS MENTAIS OU COMPORTAMENTAIS',
    codigo: 'F118',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO DE OPIÁCEOS - TRANSTORNO MENTAL OU COMPORT. Ñ ESPECIFICADO',
    codigo: 'F119',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE CANABINÓIDES',
    codigo: 'F12',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - INTOXICAÇÃO AGUDA',
    codigo: 'F120',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - USO NOCIVO PARA A SAÚDE',
    codigo: 'F121',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F122',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - SÍNDROME [ESTADO] DE ABSTINÊNCIA',
    codigo: 'F123',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - SÍNDROME DE ABSTINÊNCIA COM DELÍRIO',
    codigo: 'F124',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - TRANSTORNO PSICÓTICO',
    codigo: 'F125',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - SÍNDROME AMNÉSICA',
    codigo: 'F126',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - TRANST. PSICÓT. RESIDUAL OU DE INSTAL. TARDIA',
    codigo: 'F127',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - OUTROS TRANSTORNOS MENTAIS OU COMPORTAMENTAIS',
    codigo: 'F128',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO CANABINÓIDES - TRANSTORNO MENTAL OU COMPORT. Ñ ESPECIFICADO',
    codigo: 'F129',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE SEDATIVOS E HIPNÓTICOS',
    codigo: 'F13',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - INTOXICAÇÃO AGUDA',
    codigo: 'F130',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - USO NOCIVO PARA A SAÚDE',
    codigo: 'F131',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F132',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - SÍNDROME [ESTADO] DE ABSTINÊNCIA',
    codigo: 'F133',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - SÍNDROME DE ABSTINÊNCIA COM DELÍRIO',
    codigo: 'F134',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - TRANSTORNO PSICÓTICO',
    codigo: 'F135',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - SÍNDROME AMNÉSICA',
    codigo: 'F136',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - TRANST. PSICÓT. RESIDUAL OU INSTAL. TARDIA',
    codigo: 'F137',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - OUTR. TRANSTORNOS MENTAIS/COMPORTAMENTAIS',
    codigo: 'F138',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SEDAT./HIPNÓT. - TRANST. MENTAL OU COMPORT. Ñ ESPECIFICADO',
    codigo: 'F139',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DA COCAÍNA',
    codigo: 'F14',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - INTOXICAÇÃO AGUDA',
    codigo: 'F140',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - USO NOCIVO PARA A SAÚDE',
    codigo: 'F141',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F142',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - SÍNDROME [ESTADO] DE ABSTINÊNCIA',
    codigo: 'F143',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - SÍNDROME DE ABSTINÊNCIA C/ DELÍRIO',
    codigo: 'F144',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - TRANSTORNO PSICÓTICO',
    codigo: 'F145',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - SÍNDROME AMNÉSICA',
    codigo: 'F146',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - TRANST. PSICÓTICO RESIDUAL OU DE INSTALAÇÃO TARDIA',
    codigo: 'F147',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - OUTROS TRANSTORNOS MENTAIS OU COMPORTAMENTAIS',
    codigo: 'F148',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO COCAÍNA - TRANSTORNO MENTAL OU COMPORTAMENTAL Ñ ESPECIFICADO',
    codigo: 'F149',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE OUTROS ESTIMULANTES, INCLUSIVE A CAFEÍNA',
    codigo: 'F15',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - INTOXICAÇÃO AGUDA',
    codigo: 'F150',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - USO NOCIVO PARA A SAÚDE',
    codigo: 'F151',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F152',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - SÍNDROME DE ABSTINÊNCIA',
    codigo: 'F153',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - SÍNDROME DE ABSTIN. C/DELÍRIO',
    codigo: 'F154',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - TRANSTORNO PSICÓTICO',
    codigo: 'F155',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - SÍNDROME AMNÉSICA',
    codigo: 'F156',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - TRANST. PSIC. RESIDUAL/INST.TARDIA',
    codigo: 'F157',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - OUT. TRANST. MENTAIS OU COMPORTAM.',
    codigo: 'F158',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ESTIMUL., INCL. CAFEÍNA - TRANST. MENTAL/COMPORT. Ñ ESPECIF.',
    codigo: 'F159',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE ALUCINÓGENOS',
    codigo: 'F16',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - INTOXICAÇÃO AGUDA',
    codigo: 'F160',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - USO NOCIVO PARA A SAÚDE',
    codigo: 'F161',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F162',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - SÍNDROME DE ABSTINÊNCIA',
    codigo: 'F163',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - SÍNDROME DE ABSTINÊNCIA COM DELÍRIO',
    codigo: 'F164',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - TRANSTORNO PSICÓTICO',
    codigo: 'F165',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - SÍNDROME AMNÉSICA',
    codigo: 'F166',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - TRANST. PSICÓTICO RESID. OU DE INSTAL. TARDIA',
    codigo: 'F167',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - OUTROS TRANST. MENTAIS OU COMPORTAMENTAIS',
    codigo: 'F168',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO ALUCINÓGENOS - TRANST. MENTAL OU COMPORT. NÃO ESPECIFICADO',
    codigo: 'F169',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE SOLVENTES VOLÁTEIS',
    codigo: 'F18',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - INTOXICAÇÃO AGUDA',
    codigo: 'F180',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - USO NOCIVO PARA A SAÚDE',
    codigo: 'F181',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F182',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - SÍNDROME [ESTADO] DE ABSTINÊNCIA',
    codigo: 'F183',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - SÍNDROME DE ABSTINÊNCIA COM DELÍRIO',
    codigo: 'F184',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - TRANSTORNO PSICÓTICO',
    codigo: 'F185',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - SÍNDROME AMNÉSICA',
    codigo: 'F186',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - TRANST. PSIC. RESID. OU DE INST. TARDIA',
    codigo: 'F187',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - OUT. TRANST. MENTAIS OU COMPORTAMENTAIS',
    codigo: 'F188',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORT. DEV. USO SOLVENTES VOLÁTEIS - TRANST. MENTAL OU COMPORT. NÃO ESPECIF.',
    codigo: 'F189',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANSTORNOS MENTAIS E COMPORTAMENTAIS DEVIDOS AO USO DE MÚLTIPLAS DROGAS E AO USO DE OUTRAS SUBSTÂNCIAS PSICOATIVAS',
    codigo: 'F19',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - INTOXICAÇÃO AGUDA',
    codigo: 'F190',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - USO NOCIVO PARA A SAÚDE',
    codigo: 'F191',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - SÍNDROME DE DEPENDÊNCIA',
    codigo: 'F192',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - SÍNDROME DE ABSTINÊNCIA',
    codigo: 'F193',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - SÍNDROME DE ABSTINÊNCIA C/ DELÍRIO',
    codigo: 'F194',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - TRANSTORNO PSICÓTICO',
    codigo: 'F195',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - SÍNDROME AMNÉSICA',
    codigo: 'F196',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - TRANST. PSIC. RESID./INST. TARDIA',
    codigo: 'F197',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - OUT. TRANST. MENTAIS/COMPORTAMENT.',
    codigo: 'F198',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'TRANST. MENTAIS/COMPORT. DEV. USO MÚLT. DROGAS/OUT. PSICOATIVAS - TRANST. MENTAL/COMPORT. Ñ ESPECIF.',
    codigo: 'F199',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'PRESENÇA DE OPIÁCEOS NO SANGUE',
    codigo: 'R781',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'PRESENÇA DE COCAÍNA NO SANGUE',
    codigo: 'R782',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'PRESENÇA DE ALUCINÓGENO NO SANGUE',
    codigo: 'R783',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'PRESENÇA DE OUTRAS DROGAS COM POTENCIAL DE CAUSAR DEPENDÊNCIA, NO SANGUE',
    codigo: 'R784',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'PRESENÇA DE DROGA PSICOTRÓPICA NO SANGUE',
    codigo: 'R785',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'REABILITAÇÃO DE TOXICODEPENDENTES',
    codigo: 'Z503',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'ACONSELHAMENTO E SUPERVISÃO PARA ABUSO DE DROGAS',
    codigo: 'Z715',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'USO DE DROGA',
    codigo: 'Z722',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
]
